export default {
    "A name is required": "Se requiere un nombre",
    "Age": "Años",
    "Total money spent, $": "Total de dinero gastado, $",
    "Clients": "Clientela",
    "Income": "Ingresos",
    "First name": "Nombre de pila",
    "Last name": "Apellido",
    "Position": "El oficio",
    "Click para seleccionar ": "Clic para seleccionar",
    "Notifications": "Notificaciones",
    "Yes": "Sí",
    "No": "No",
    "City, country": "Ciudad, País",
    "Address": "Dirección",
    "Birthday": "Cumpleaños",
    "Click to add tags": "Haga clic para agregar etiquetas",
    "Notes": "Notas",
    "Reset": "Reiniciar",
    "Save": "Guardar",
    "Top clients": "Principales clientes",
    "Money spent, $": "Dinero gastado, $",
    "-- Not selected --": "-- No seleccionado --",
    "Sales manager": "Gerente de ventas",
    "Customer service": "Servicio al cliente",
    "General manager": "Gerente general",
    "Awarded Badges": "Insignias otorgadas",
    "New": "Nuevo",
    "Customer": "Cliente",
    "Supplier": "Proveedor",
    "Discount": "Descuento",
    "Old Buddy": "Viejo Amigo",
    "Avid Supporter": "Ansioso Seguidor",
    "Date": "Fecha",
    "Payment": "Pago",
    "Purchase": "Compra",
    "Sum": "Suma",
    "Left": "Izquierda",
    "Nothing on this day": "Nada en este día",
    "Information": "Información",
    "Statistics": "Estadística",
    "Transactions": "Actas",
    "Customers": "Clientes",
    "Charts": "Gráficos",
    "See all notifications": "Todas las notificaciones",
    "Deposits News": "Depósitos Noticias",
    "Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...": "Estimado cliente, le informamos sobre los siguientes cambios: a partir del 24 de septiembre de 2018 todas las transacciones (entrantes y salientes...",
    "Search Improved": "Búsqueda mejorada",
    "Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...": "¡Estimado cliente! Después de las últimas actualizaciones de los motores SeekMeEverywhere, ¡su búsqueda se ha vuelto más confiable y conveniente! Ahora...",
    "Transaction Reports": "Informes de transacciones",
    "Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...": "Estimado cliente, le informamos sobre un cambio en la fecha de los informes de transacciones mensuales. A partir del 20 de septiembre de 2018 informa...",
    "Warning": "Advertencia",
    "Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.": "Estimado cliente, sabemos dónde almacena sus contraseñas. Le recomendamos encarecidamente que los memorice y destruya esos memorandos suyos.",
    "Editing customers data": "Editando datos de clientes",
    "Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.": "Estimado cliente, si desea ver los detalles de cada cliente y editarlos, haga doble clic en el cliente en la lista a la derecha.",
    "We miss you": "Te extrañamos",
    "Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.": "Estimado cliente, ha pasado un tiempo desde que habló con nosotros. Te estamos esperando en el mismo lugar al mismo tiempo.",
    "Have a nice day": "Que tengas un buen día",
    "Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.": "Estimado cliente, cada vez que esté leyendo esto, le deseamos un feliz día. Que la suerte y el éxito te atiendan.",
    "Localization": "Localización",
    "Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.": "Estimado cliente, puede elegir uno de los seis idiomas que proporcionamos para esta aplicación de demostración. Haga clic en el icono en la esquina superior derecha.",
    "We love you": "Te amamos",
    "Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.": "Estimado cliente, lo queremos mucho. Si nuestros sentimientos son mutuos, contáctenos y descargue Webix. Entonces te amaremos eternamente.",
    "Persons": "Personas",
    "Click twice to see more goodies": "Haga clic dos veces para ver más regalos",
    "Saved": "Salvado",
    "Settings": "Configuraciones",
    "Regional settings": "Ajustes regionales",
    "Language": "Idioma",
    "Date format": "Formato de fecha",
    "Money format": "Formato de dinero",
    "Environment settings": "Configuraciones del entorno",
    "Theme": "Tema",
    "Light": "Ligero",
    "Dark": "Oscuro",
    "Max list length": "Longitud máxima de la lista",
    "Default settings": "Configuración por defecto",
    "Open latest notifications": "Abrir las últimas notificaciones",
    "Go to settings": "Ir a la configuración",
    "All": "Todas",
    "Payments": "Pagos",
    "Incoming": "Entrante",
    "Email": "Email",
    "Widgets": "Widgets",
    "Demos": "Población",
    "Prices": "Precios",
    "Tutorials": "Tutoriales",
    "Tirane, Albania": "Tirana, Albania",
    "Buenos Aires, Argentina": "Buenos Aires, Argentina",
    "Canberra, Australia": "Canberra, Australia",
    "Vienna, Austria": "Viena, Austria",
    "Minsk, Belarus": "Minsk, Bielorrusia",
    "Brussels, Belgium": "Bruselas, Belgica",
    "Brasilia, Brazil": "Brasilia, Brasil",
    "Ottawa, Canada": "Ottawa, Canadá",
    "Beijing, China": "Beijing, China",
    "Prague, Czech Republic": "Praga, República Checa",
    "Copenhagen, Denmark": "Copenhague, Dinamarca",
    "Cairo, Egypt": "El Cairo, Egipto",
    "Helsinki, Finland": "Helsinki, Finlandia",
    "Paris, France": "París, Francia",
    "Tbilisi, Georgia": "Tbilisi, Georgia",
    "Berlin, Germany": "Berlín, Alemania",
    "New Delhi, India": "Nueva Delhi, India",
    "Dublin, Ireland": "Dublín, Irlanda",
    "Rome, Italy": "Roma, Italia",
    "Tokyo, Japan": "Tokio, Japón",
    "Wellington, New Zealand": "Wellington, Nueva Zelanda",
    "Seoul, Republic of Korea": "Seúl, República de Corea",
    "Madrid, Spain": "Madrid, España",
    "Stockholm, Sweden": "Estocolmo, Suiza",
    "Washington, United States": "Washington, Estados Unidos",
    "Payment History": "Historial de pagos",
    "Origin of clients": "Origen de los clientes",
    "Income from various age groups": "Ingresos de varios grupos de edad",
    "Clients by occupation": "Clientes por ocupación",
    "No new notifications": "No hay nuevas notificaciones",


    "Añadir Egreso": "Añadir Egreso",
    "Añadir Ingreso": "Añadir Ingreso",
    "Saldo Recargas:": "Saldo Recargas:",
    "Saldo Juego:": "Saldo Juego:",
    "Nombre": "Nombre",
    "Hoy": "Hoy",
    "Ayer": "Ayer",
    "Ultimos 30 días": "Ultimos 30 días",
    "Depósitos": "Depósitos",
    "Retiros": "Retiros",
    "Neto": "Neto",
    "Desea cambiar la contraseña?": "Desea cambiar la contraseña?",
    "Salir": "Salir",
    "Descripción": "Descripción",
    "Activado": "Activado",
    "Inactivado": "Inactivado",


    "Número de usuario": "Número de usuario",
    "Login para acceso": "Login para acceso",
    "Última dirección IP": "Última dirección IP",
    "Último usuario modif": "Último usuario modif",
    "Tipo": "Tipo",
    "Agente": "Agente",
    "Afiliado": "Afiliado",
    "Click para seleccionar": "Click para seleccionar",
    "Estado": "Estado",
    "Activo": "Activo",
    "Inactivo": "Inactivo",
    "Retirado": "Retirado",
    "Idioma preferido:": "Idioma preferido:",
    "Nombre del usuario": "Nombre del usuario",
    "País": "País",
    "Campo Requerido": "Campo Requerido",
    "Moneda": "Moneda",
    "Fecha de creación": "Fecha de creación",
    "Fecha última entrada": "Fecha última entrada",
    "Última Fecha modif": "Última Fecha modif",
    "Estado especial": "Estado especial",
    "Pinagent": "Pinagent",
    "Sí": "Sí",
    "Bloqueado para ventas": "Bloqueado para ventas",
    "Imprime recibo caja": "Imprime recibo caja",
    "Permite recargas": "Permite recargas",
    "Permite activar reg": "Permite activar reg",
    "Nombre del contacto": "Nombre del contacto",
    "Correo electrónico": "Correo electrónico",
    "Teléfono": "Teléfono",
    "Concesionario": "Concesionario",
    "Subconcesionario": "Subconcesionario",
    "Provincia/Región": "Provincia/Región",
    "Ciudad": "Ciudad",
    "Dirección": "Dirección",
    "Barrio": "Barrio",
    "Limite diario de recargas": "Limite diario de recargas",
    "Comisión recargas": "Comisión recargas",
    "Apuesta mínima": "Apuesta mínima",
    "Límite diario": "Límite diario",
    "Datos Principales": "Datos Principales",
    "Datos Agente": "Datos Agente",
    "Datos Configuracion": "Datos Configuracion",
    "Limpiar": "Limpiar",
    "Guardar": "Guardar",
    "Completa los campos...": "Completa los campos...",
    "Mi Información": "Mi Información",
    "Contraseña Actual": "Contraseña Actual",
    "Nueva Contraseña": "Nueva Contraseña",
    "La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.": "La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.",
    "Confirmar Contraseña": "Confirmar Contraseña",
    "Contraseñas no coinciden": "Contraseñas no coinciden",
    "Advertencia!": "Advertencia!",
    "Contraseña cambiada satisfactoriamente": "Contraseña cambiada satisfactoriamente",
    "¡Exito!": "¡Exito!",
    "Nueva contraseñas no coinciden": "Nueva contraseñas no coinciden",
    "Verifique los campos...": "Verifique los campos...",
    "Cambiar mi contraseña": "Cambiar mi contraseña",
    "Slug": "Slug",
    "Superior": "Superior",
    "Editar Categoría": "Editar Categoría",
    "Cancelar": "Cancelar",
    "Categoría Editada": "Categoría Editada",
    "Añadir Categoría": "Añadir Categoría",
    "Categoría Agregada": "Categoría Agregada",
    "Todos": "Todos",
    "Filtros Avanzados": "Filtros Avanzados",
    "Consultar": "Consultar",
    "Categoría": "Categoría",
    "Productos": "Productos",
    "Agragar Categoría Producto": "Agragar Categoría Producto",
    "Categoría Producto Editada": "Categoría Producto Editada",
    "Editar Categorias Productos": "Editar Categorias Productos",
    "Categoría Producto Agregada": "Categoría Producto Agregada",
    "Categorías": "Categorías",
    "Añadir Categoría Producto": "Añadir Categoría Producto",
    "Nombre Encargado": "Nombre Encargado",
    "Nit": "Nit",
    "Es propio?": "Es propio?",
    "Añadir Tipo Producto Partner": "Añadir Tipo Producto Partner",
    "Partner Agregado": "Partner Agregado",
    "Añadir Partner": "Añadir Partner",
    "Producto": "Producto",
    "Proveedor": "Proveedor",
    "Partner": "Partner",
    "Verificado": "Verificado",
    "Filtro País": "Filtro País",
    "Mobile": "Mobile",
    "Escritorio": "Escritorio",
    "Máximo": "Máximo",
    "Mínimo": "Mínimo",
    "Tiempo Procesamiento": "Tiempo Procesamiento",
    "Orden": "Orden",
    "Orden Destacado": "Orden Destacado",
    "Filas": "Filas",
    "Columnas": "Columnas",
    "Editar Productos Partner": "Editar Productos Partner",
    "Producto Partner Editado": "Producto Partner Editado",
    "Añadir Producto Partner": "Añadir Producto Partner",
    "Producto Partner Agregado": "Producto Partner Agregado",
    "Dispositivo": "Dispositivo",
    "Editar": "Editar",
    "Detalle": "Detalle",
    "Editar Partner": "Editar Partner",
    "Proveedores": "Proveedores",
    "Proveedor Partner Agregado": "Proveedor Partner Agregado",
    "Proveedor Partner Editado": "Proveedor Partner Editado",
    "Imagen": "Imagen",
    "Imagen URL": "Imagen URL",
    "ID Externo": "ID Externo",
    "Visible": "Visible",
    "Producto Id": "Producto Id",
    "Editar Producto": "Editar Producto",
    "Añadir Producto": "Añadir Producto",
    "Abreviado": "Abreviado",
    "Proveedor Id": "Proveedor Id",
    "Ambos": "Ambos",
    "ID Usuario": "ID Usuario",
    "Usuario (Correo electrónico)": "Usuario (Correo electrónico)",
    "Apellido": "Apellido",
    "Documento": "Documento",
    "Estado de Registro": "Estado de Registro",
    "Rechazado": "Rechazado",
    "Bloqueado": "Bloqueado",
    "Fecha de ultimo login": "Fecha de ultimo login",
    "Codigo Promocional": "Codigo Promocional",
    "Desea activar registro?": "Desea activar registro?",
    "Activar registro": "Activar registro",
    "Ocurrio un error, comuniquese con soporte": "Ocurrio un error, comuniquese con soporte",
    "No puedes activar un registro ya actualizado.": "No puedes activar un registro ya actualizado.",
    "Desea rechazar registro?": "Desea rechazar registro?",
    "Rechazar registro": "Rechazar registro",
    "Error": "Error",
    "¡Error!": "¡Error!",
    "Medio de Registro": "Medio de Registro",
    "Sub Categoría": "Sub Categoría",
    "Fecha final de la autoexclusión": "Fecha final de la autoexclusión",
    "Usuario Creación": "Usuario Creación",
    "Usuario Modificó": "Usuario Modificó",
    "Juego": "Juego",
    "Tipo saldo": "Tipo saldo",
    "Saldo recargas": "Saldo recargas",
    "Saldo retiros": "Saldo retiros",
    "Detalles": "Detalles",
    "Historial": "Historial",
    "None": "None",
    "Cancelado": "Cancelado",
    "Añadir Ajuste": "Añadir Ajuste",
    "Nombre Usuario": "Nombre Usuario",
    "Movimiento": "Movimiento",
    "Entrada": "Entrada",
    "Salida": "Salida",
    "Cancelación": "Cancelación",
    "Valor": "Valor",
    "Respuesta": "Respuesta",
    "Cerrado": "Cerrado",
    "Detalles del Ticket": "Detalles del Ticket",
    "Ticket Det Id": "Ticket Det Id",
    "Ticket ID": "Ticket ID",
    "Market": "Market",
    "Fecha": "Fecha",
    "Transacción ID": "Transacción ID",
    "Monto": "Monto",
    "Historial de Transacciones": "Historial de Transacciones",
    "Usuario": "Usuario",
    "Premios": "Premios",
    "Pendiente": "Pendiente",
    "Redimido": "Redimido",
    "Expirado": "Expirado",
    "Libre": "Libre",
    "Deposito": "Deposito",
    "No Deposito": "No Deposito",
    "Partner Bono Id": "Partner Bono Id",
    "Bono ID": "Bono ID",
    "ID Cliente": "ID Cliente",
    "Id Bono": "Id Bono",
    "Nombre de Bono": "Nombre de Bono",
    "Fecha Aceptación": "Fecha Aceptación",
    "Fecha Modificación": "Fecha Modificación",
    "Monto Convertido": "Monto Convertido",
    "Rollover Requerido": "Rollover Requerido",
    "Apostado": "Apostado",
    "Restante": "Restante",
    "Fecha Expiración": "Fecha Expiración",
    "Apuestas": "Apuestas",
    "Ganancias": "Ganancias",
    "Premios Bonos": "Premios Bonos",
    "Beneficio %": "Beneficio %",
    "Nombre Sistema Pasarela Pago": "Nombre Sistema Pasarela Pago",
    "Pagada": "Pagada",
    "Rechazada": "Rechazada",
    "Detallado": "Detallado",
    "Totales": "Totales",
    "Resumen Financiero": "Resumen Financiero",
    "Ajustar Saldo": "Ajustar Saldo",
    "Usuario Id:": "Usuario Id:",
    "Tipo Saldo:": "Tipo Saldo:",
    "Monto:": "Monto:",
    "Transacción Id": "Transacción Id",
    "Abierto": "Abierto",
    "Ganó": "Ganó",
    "Perdió": "Perdió",
    "No Acción": "No Acción",
    "En Espera": "En Espera",
    "Rechazada por Regla": "Rechazada por Regla",
    "Retiro Voluntario": "Retiro Voluntario",
    "Dirección IP": "Dirección IP",
    "Odds": "Odds",
    "Cambiar Contraseña": "Cambiar Contraseña",
    "Código": "Código",
    "Generar Token": "Generar Token",
    "Desbloquear Usuario por Clave": "Desbloquear Usuario por Clave",
    "Desbloquear": "Desbloquear",
    "Ocurrio un error.": "Ocurrio un error.",
    "Cambios Realizados": "Cambios Realizados",
    "Estado de Usuario": "Estado de Usuario",
    "Estado de Contingencia": "Estado de Contingencia",
    "Contingencia Deportivas": "Contingencia Deportivas",
    "Contingencia Casino": "Contingencia Casino",
    "Contingencia Casino en Vivo": "Contingencia Casino en Vivo",
    "Estado de Contingencia Virtuales": "Estado de Contingencia Virtuales",
    "Estado de Contingencia Poker": "Estado de Contingencia Poker",
    "Estado de Registro del Usuario": "Estado de Registro del Usuario",
    "Verificó DNI anterior": "Verificó DNI anterior",
    "Verificó DNI posterior": "Verificó DNI posterior",
    "Nombre sistema de pago": "Nombre sistema de pago",
    "ID Cuenta": "ID Cuenta",
    "Banco": "Banco",
    "Número Cuenta Bancaria": "Número Cuenta Bancaria",
    "Código Interbancario": "Código Interbancario",
    "Tipo Cuenta": "Tipo Cuenta",
    "Ahorros": "Ahorros",
    "Corriente": "Corriente",
    "Cuenta Bancaria editada satisfactoriamente": "Cuenta Bancaria editada satisfactoriamente",
    "Formas de Pago": "Formas de Pago",
    "Efectivo": "Efectivo",
    "Cuenta Bancaria": "Cuenta Bancaria",
    "Giro Bancario": "Giro Bancario",
    "Punto de Venta": "Punto de Venta",
    "Filtros": "Filtros",
    "Seguridad Cambios": "Seguridad Cambios",
    "Exportar": "Exportar",
    "Cuentas Bancarias": "Cuentas Bancarias",
    "Total Depósitos": "Total Depósitos",
    "Total Apuestas Deportivas": "Total Apuestas Deportivas",
    "Total Ganancias Deportivas": "Total Ganancias Deportivas",
    "Total Apuestas Casino": "Total Apuestas Casino",
    "Ganancias Totales Casino": "Ganancias Totales Casino",
    "Total Retiros": "Total Retiros",
    "Total Ajustes Entrada": "Total Ajustes Entrada",
    "Total Ajustes Salida": "Total Ajustes Salida",
    "Detalles Avanzados": "Detalles Avanzados",
    "Guardado": "Guardado",
    "Error! ": "Error! ",
    "Añadir Cuenta": "Añadir Cuenta",
    "Cuenta": "Cuenta",
    "Editar Cuenta": "Editar Cuenta",
    "Cuenta Actualizado": "Cuenta Actualizado",
    "Cuenta Agregado": "Cuenta Agregado",
    "Encargado": "Encargado",
    "Añadir Área": "Añadir Área",
    "Editar Área": "Editar Área",
    "Área Actualizado": "Área Actualizado",
    "Área Agregado": "Área Agregado",
    "Datos no han podido ser cargados": "Datos no han podido ser cargados",
    "Hora Inicio": "Hora Inicio",
    "Hora Cierre": "Hora Cierre",
    "ID Plan de Cuentas": "ID Plan de Cuentas",
    "Referencia": "Referencia",
    "Añadir Concepto": "Añadir Concepto",
    "Plan de cuenta": "Plan de cuenta",
    "Cuenta Id": "Cuenta Id",
    "Editar Concepto": "Editar Concepto",
    "Concepto Actualizado": "Concepto Actualizado",
    "Concepto Agregado": "Concepto Agregado",
    "Tipo de Centro": "Tipo de Centro",
    "Añadir Centro": "Añadir Centro",
    "Editar Centro": "Editar Centro",
    "Centro Actualizado": "Centro Actualizado",
    "Centro Agregado": "Centro Agregado",
    "Área": "Área",
    "Cargo": "Cargo",
    "Añadir Empleado": "Añadir Empleado",
    "Tipo Documento": "Tipo Documento",
    "Cedula": "Cedula",
    "Cedula de extrangería": "Cedula de extrangería",
    "Pasaporte": "Pasaporte",
    "Salario": "Salario",
    "Empleado Agregado": "Empleado Agregado",
    "Editar Empleado": "Editar Empleado",
    "Empleado Actualizado": "Empleado Actualizado",
    "Consecutivo": "Consecutivo",
    "Tarjeta de crédito": "Tarjeta de crédito",
    "Tipo de Egreso": "Tipo de Egreso",
    "Documento ID": "Documento ID",
    "Centro de Costos": "Centro de Costos",
    "Concepto": "Concepto",
    "Creador": "Creador",
    "Impuesto": "Impuesto",
    "Retracción": "Retracción",
    "Añadir Gasto": "Añadir Gasto",
    "Es punto de venta?": "Es punto de venta?",
    "Gasto Agregado": "Gasto Agregado",
    "Factura": "Factura",
    "Editar Gasto": "Editar Gasto",
    "Gasto Actualizado": "Gasto Actualizado",
    "Tipo de Ingreso": "Tipo de Ingreso",
    "Soporte": "Soporte",
    "Ingreso Agregado": "Ingreso Agregado",
    "Ingreso Actualizado": "Ingreso Actualizado",
    "Añadir Cargo": "Añadir Cargo",
    "Tipo Cargo": "Tipo Cargo",
    "Cargo Agregado": "Cargo Agregado",
    "Productos Internos?": "Productos Internos?",
    "Añadir Producto Tercero": "Añadir Producto Tercero",
    "Cuenta Contable Ingreso": "Cuenta Contable Ingreso",
    "Cuenta Contable Egreso": "Cuenta Contable Egreso",
    "Producto Interno?": "Producto Interno?",
    "Tipo Interno": "Tipo Interno",
    "Plan cuentas Apuestas Tickets Tiendas": "Plan cuentas Apuestas Tickets Tiendas",
    "Plan cuentas Premios Tickets Tiendas": "Plan cuentas Premios Tickets Tiendas",
    "Plan cuentas Pagos notas de retiro": "Plan cuentas Pagos notas de retiro",
    "Plan de cuentas Recargas": "Plan de cuentas Recargas",
    "Editar Producto Tercero": "Editar Producto Tercero",
    "Producto Tercero Agregado": "Producto Tercero Agregado",
    "Producto Tercero Actualizado": "Producto Tercero Actualizado",
    "Producto Terceros": "Producto Terceros",
    "Añadir": "Añadir",
    "Cuenta Contable": "Cuenta Contable",
    "Agregada": "Agregada",
    "RUC - NIT": "RUC - NIT",
    "Añadir Proveedor": "Añadir Proveedor",
    "Proveedor Agregado": "Proveedor Agregado",
    "Proveedor Actualizado": "Proveedor Actualizado",
    "Valor Entradas": "Valor Entradas",
    "Valor Salidas": "Valor Salidas",
    "Nivel": "Nivel",
    "Con Cajero": "Con Cajero",
    "Centro": "Centro",
    "Añadir Tipo": "Añadir Tipo",
    "Editar Tipo": "Editar Tipo",
    "Tipo Actualizado": "Tipo Actualizado",
    "Tipo Agregado": "Tipo Agregado",
    "Plan de Cuentas": "Plan de Cuentas",
    "Areas": "Areas",
    "Empleados": "Empleados",
    "Reporte de cierre de día": "Reporte de cierre de día",
    "Conceptos": "Conceptos",
    "Egresos": "Egresos",
    "Reporte de Gastos": "Reporte de Gastos",
    "Ingresos": "Ingresos",
    "Otros Ingresos": "Otros Ingresos",
    "Cargos": "Cargos",
    "Producto Tercero": "Producto Tercero",
    "Producto Tercero Punto de Venta": "Producto Tercero Punto de Venta",
    "Productos Terceros": "Productos Terceros",
    "Productos Terceros Punto de Venta": "Productos Terceros Punto de Venta",
    "Reporte de Cuadre de día": "Reporte de Cuadre de día",
    "Reporte de Cuadre de día 2": "Reporte de Cuadre de día 2",
    "Tipos": "Tipos",
    "Añadir Tipos": "Añadir Tipos",
    "Afiliador": "Afiliador",
    "No Procesado": "No Procesado",
    "Añadir Agente": "Añadir Agente",
    "Estado Validación": "Estado Validación",
    "Región": "Región",
    "Departamento": "Departamento",
    "Modificado": "Modificado",
    "¿ Qué desea realizar ?": "¿ Qué desea realizar ?",
    "Traslado a Saldo Recargas": "Traslado a Saldo Recargas",
    "Traslado a Saldo Juego": "Traslado a Saldo Juego",
    "Transferir a saldo Recargas a ": "Transferir a saldo Recargas a ",
    "Transferir": "Transferir",
    "No Se ha realizado la transferencia. Comunicarse con soporte. ": "No Se ha realizado la transferencia. Comunicarse con soporte. ",
    "Se ha realizado la transferencia satisfactoriamente. ": "Se ha realizado la transferencia satisfactoriamente. ",
    "Transferir a Saldo Juego a ": "Transferir a Saldo Juego a ",
    "Saldo Juego Actual": "Saldo Juego Actual",
    "Saldo Recargas Actual": "Saldo Recargas Actual",
    "Saldo de Recargas": "Saldo de Recargas",
    "Saldo de Juego": "Saldo de Juego",
    "Confirmar Valor": "Confirmar Valor",
    "Recargar": "Recargar",
    "Los montos no coinciden": "Los montos no coinciden",
    "Cupos Asignados": "Cupos Asignados",
    "Historial cambios de cupo ": "Historial cambios de cupo ",
    "Tipo Cupo": "Tipo Cupo",
    "Recargas": "Recargas",
    "Tipo Transacción": "Tipo Transacción",
    "Asignado Por": "Asignado Por",
    "Comisión Nivel 1": "Comisión Nivel 1",
    "Comisión Nivel 2": "Comisión Nivel 2",
    "Comisión Nivel 3": "Comisión Nivel 3",
    "Comisión Nivel 4": "Comisión Nivel 4",
    "Comisión Punto": "Comisión Punto",
    "Editar Comisión": "Editar Comisión",
    "Valores Editados": "Valores Editados",
    "Mensual": "Mensual",
    "Diario": "Diario",
    "Valor Base": "Valor Base",
    "Comision": "Comision",
    "Valor Pagado": "Valor Pagado",
    "External ID": "External ID",
    "Pregunta": "Pregunta",
    "Saldo Afiliados": "Saldo Afiliados",
    "Desea pagar comisión en efectivo?": "Desea pagar comisión en efectivo?",
    "Comisión Pagada": "Comisión Pagada",
    "Desea abonar comisión a saldo recargas?": "Desea abonar comisión a saldo recargas?",
    "Desea abonar comisión a saldo juego?": "Desea abonar comisión a saldo juego?",
    "Desea abonar comisión a saldo afiliados?": "Desea abonar comisión a saldo afiliados?",
    "Desea Aprobar Comisión": "Desea Aprobar Comisión",
    "Aprobar Comisión": "Aprobar Comisión",
    "Comisión Aprobado": "Comision Aprobado",
    "Restricción IP": "Restricción IP",
    "Token Google": "Token Google",
    "Token Local": "Token Local",
    "No tienes un QR Configurado.": "No tienes un QR Configurado.",
    "UserModifId": "UserModifId",
    "Comisiones": "Comisiones",
    "Apuestas Totales Liquidadas": "Apuestas Totales Liquidadas",
    "Deporte Profitness": "Deporte Profitness",
    "Casino Profitness": "Casino Profitness",
    "Reporte de Retiros": "Reporte de Retiros",
    "Tipo de Apuesta": "Tipo de Apuesta",
    "Apuestas Creadas": "Apuestas Creadas",
    "Apuestas Cerradas": "Apuestas Cerradas",
    "Apuestas Pagadas": "Apuestas Pagadas",
    "Cantidad Tickets": "Cantidad Tickets",
    "Stake": "Stake",
    "Stake Promedio": "Stake Promedio",
    "Payout": "Payout",
    "Bonos": "Bonos",
    "Bonos1": "Bonos",
    "Fecha Creación": "Fecha Creación",
    "Pendientes": "Pendientes",
    "Acción": "Acción",
    "Bono Deposito": "Bono Deposito",
    "Bono No Deposito": "Bono No Deposito",
    "Freebet": "Freebet",
    "Presupuesto": "Presupuesto",
    "Aprobado": "Aprobado",
    "Responder Solicitud": "Responder Solicitud",
    "Respuesta Generada": "Respuesta Generada",
    "Envie una Respuesta": "Envie una Respuesta",
    "Aprobar Solicitud": "Aprobar Solicitud",
    "Rechazar Solicitud": "Rechazar Solicitud",
    "Requisitos": "Requisitos",
    "Historial de requisitos enviados": "Historial de requisitos enviados",
    "Requisito": "Requisito",
    "Añadir Requisito": "Añadir Requisito",
    "Tipo Usuario": "Tipo Usuario",
    "Editar Requisito": "Editar Requisito",
    "Nombre:": "Nombre:",
    "Tipo Usuario:": "Tipo Usuario:",
    "Requisito Editado": "Requisito Editado",
    "Requisito Agregado": "Requisito Agregado",
    "Estadisticas Marketing": "Estadisticas Marketing",
    "Marketing Vs Registros": "Marketing Vs Registros",
    "Top Usuarios": "Top Usuarios",
    "Clave": "Clave",
    "Datos Configuración": "Datos Configuración",
    "Reporte de Bonos": "Reporte de Bonos",
    "Reporte de Casino": "Reporte productos no deportivos",
    "Reporte de Comisiones": "Reporte de Comisiones",
    "Reporte de Comisiones Detallado": "Reporte de Comisiones Detallado",
    "QR Google": "QR Google",
    "Reporte de Depósitos": "Reporte de Depósitos",
    "Reporte de Depósitos por Franquicias": "Reporte de Depósitos por Franquicias",
    "Franquicia": "Franquicia",
    "Franquicias": "Franquicias",
    "Producto de Pago": "Producto de Pago",
    "Vista": "Vista",
    "Vista Resumida": "Vista Resumida",
    "Vista Detallada": "Vista Detallada",
    "Estado del Depósito": "Estado del Depósito",
    "Enviada": "Enviada",
    "Cantidad de Usuarios": "Cantidad de Usuarios",
    "Cantidad de Depósitos": "Cantidad de Depósitos",
    "Franquicia / Pasarela": "Franquicia / Pasarela",
    "Notas": "Notas",
    "Impuesto Deposito": "Impuesto Deposito",
    "No se pudo consultar el reporte. Intente nuevamente.": "No se pudo consultar el reporte. Intente nuevamente.",
    "No se pudo consultar el reporte.": "No se pudo consultar el reporte.",
    "Se muestran los primeros": "Se muestran los primeros",
    "resultados de": "resultados de",
    "Refine los filtros para acotar la búsqueda.": "Refine los filtros para acotar la búsqueda.",
    "Flujo de Caja": "Flujo de Caja",
    "Reporte de Flujo de Caja": "Reporte de Flujo de Caja",
    "Flujo de caja hijos": "Flujo de caja hijos",
    "Reporte de Flujo de Caja Hijos": "Reporte de Flujo de Caja Hijos",
    "Reporte de Apuestas": "Reporte de Apuestas",
    "Flujo Caja Hijos": "Flujo Caja Hijos",
    "Usuarios Afiliados": "Usuarios Afiliados",
    "Marketing": "Marketing",
    "Informe": "Informe",
    "Códigos Promocionales": "Códigos Promocionales",
    "Solicitudes de Agentes": "Solicitudes de Agentes",
    "Ultimos 3 días": "Ultimos 3 días",
    "Ultimos 7 días": "Ultimos 7 días",
    "Añadir Punto": "Añadir Punto",
    "Login": "Login",
    "Apuesta Total": "Apuesta Total",
    "Latitud": "Latitud",
    "Longitud": "Longitud",
    "Punto de venta Agregado": "Punto de venta Agregado",
    "Editar Punto": "Editar Punto",
    "Competencia": "Competencia",
    "Punto de venta Actualizado": "Punto de venta Actualizado",
    "Publicidad Punto": "Publicidad Punto",
    "Añadir Publicidad": "Añadir Publicidad",
    "Añadir Publicidad Cajero": "Añadir Publicidad Cajero",
    "Cajeros": "Cajeros",
    "Añadir Cajero": "Añadir Cajero",
    "Ruta": "Ruta",
    "Publicidad Añadida": "Publicidad Añadida",
    "Editar Publicidad": "Editar Publicidad",
    "Publicidad Actualizada": "Publicidad Actualizada",
    "Publicidad Cajero Añadida": "Publicidad Cajero Añadida",
    "Editar Publicidad Cajero": "Editar Publicidad Cajero",
    "Abrir Publicidad": "Abrir Publicidad",
    "Computador ID": "Computador ID",
    "Min Apuesta": "Min Apuesta",
    "Max Apuesta Live": "Max Apuesta Live",
    "Max Apuesta PreMatch": "Max Apuesta PreMatch",
    "Cajero Agregado": "Cajero Agregado",
    "Comisión Usuario": "Comisión Usuario",
    "por Abuelo": "por Abuelo",
    "por Padre": "por Padre",
    "por Hijo": "por Hijo",
    "por Nieto": "por Nieto",
    "Total": "Total",
    "Total:": "Total:",
    "Usuario REF": "Usuario REF",
    "Fecha de Creación": "Fecha de Creación",
    "Pregunta ": "Pregunta ",
    "Seleccione el tipo de saldo ": "Seleccione el tipo de saldo ",
    "Saldo Recarga": "Saldo Recarga",
    "Ganancias sujetas a impuestos": "Ganancias sujetas a impuestos",
    "Valor Apostado": "Valor Apostado",
    "Valor Premio": "Valor Premio",
    "Ganancia": "Ganancia",
    "La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ": "La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ",
    "Fecha ultima detección": "Fecha ultima detección",
    "Plataforma": "Plataforma",
    "Nombre Archivo": "Nombre Archivo",
    "Hash Original": "Hash Original",
    "Hash Detectado": "Hash Detectado",
    "Fecha modificación": "Fecha modificación",
    "Reporte de Hash": "Reporte de Hash",
    "Tecnología": "Tecnología",
    "Financiero": "Financiero",
    "Filtrar Tabla": "Filtrar Tabla",
    "Dirigido al Departamento": "Dirigido al Departamento",
    "Título de la petición": "Título de la petición",
    "Título": "Título",
    "Generar Petición": "Generar Petición",
    "Generar": "Generar",
    "Añadir Respuesta": "Añadir Respuesta",
    "Respuestas de la petición": "Respuestas de la petición",
    "La petición debe estar activa": "La petición debe estar activa",
    "Usuario Creo": "Usuario Creo",
    "Desea cerrar la petición?": "Desea cerrar la petición?",
    "Cerrar Peticíon": "Cerrar Peticíon",
    "Estado de petición actualizada": "Estado de petición actualizada",
    "Desea Activar la petición?": "Desea Activar la petición?",
    "Activar Peticíon": "Activar Peticíon",
    "Responder Petición": "Responder Petición",
    "Peticiones": "Peticiones",
    "Mensaje Id": "Mensaje Id",
    "Casino": "Casino",
    "Live Casino": "Live Casino",
    "Añadir Mensaje": "Añadir Mensaje",
    "Editar Mensaje": "Editar Mensaje",
    "Mensaje": "Mensaje",
    "Asunto": "Asunto",
    "Emisor": "Emisor",
    "Receptor": "Receptor",
    "Leido": "Leido",
    "Mensajes": "Mensajes",
    "Tipo de Producto": "Tipo de Producto",
    "Fecha Inicio": "Fecha Inicio",
    "Fecha Fin": "Fecha Fin",
    "Añadir Liga": "Añadir Liga",
    "Resultados": "Resultados",
    "Fecha del ultimo logueo": "Fecha del ultimo logueo",
    "Reporte de Apuestas Deportivas": "Reporte de Apuestas Deportivas",
    "Usuarios": "Usuarios",
    "Tabla de Resultados": "Tabla de Resultados",
    "Nro": "Nro",
    "Puntuación": "Puntuación",
    "Saldo Actual de usuarios por Edades": "Saldo Actual de usuarios por Edades",
    "Deportivo": "Deportivo",
    "Si": "Si",
    "Liga Agregada Correctamente": "Liga Agregada Correctamente",
    "La Fecha de inicio debe ser menor a la fecha fin.": "La Fecha de inicio debe ser menor a la fecha fin.",
    "Añadir Liga:": "Añadir Liga:",
    "Segundo Nombre": "Segundo Nombre",
    "Notificaciones": "Notificaciones",
    "Lista de Ligas": "Lista de Ligas",
    "Información": "Información",
    "Reportes": "Reportes",
    "Configuración": "Configuración",
    "Reporte de Usuarios": "Reporte de Usuarios",
    "Publicidad Máquina": "Publicidad Máquina",
    "Id Nota de Retiro": "Id Nota de Retiro",
    "Valor a pagar": "Valor a pagar",
    "Premio Proyectado": "Premio Proyectado",
    "Ganador": "Ganador",
    "Pagar Nota Retiro": "Pagar Nota Retiro",
    "No. Ticket": "No. Ticket",
    "Clave Ticket": "Clave Ticket",
    "Pagar Premio": "Pagar Premio",
    "Encendida": "Encendida",
    "Apagada": "Apagada",
    "Usuario Actualizó": "Usuario Actualizó",
    "Reporte de Logs": "Reporte de Logs",
    "Reporte de Actualizaciones": "Reporte de Actualizaciones",
    "Actualizar Versión ": "Actualizar Versión ",
    "Vinculo": "Vinculo",
    "Actualizar": "Actualizar",
    "Actualizar Ambos ": "Actualizar Ambos ",
    "Enviar Comando a ": "Enviar Comando a ",
    "Enviar": "Enviar",
    "Tipo Establecimiento": "Tipo Establecimiento",
    "Versión": "Versión",
    "Documento 1": "Documento 1",
    "Documento 2": "Documento 2",
    "Añadir Traducción": "Añadir Traducción",
    "Traducción Agregada": "Traducción Agregada",
    "Editar Traducción": "Editar Traducción",
    "Traducción Editada": "Traducción Editada",
    "Obtener URL": "Obtener URL",
    "Subir Imagen": "Subir Imagen",
    "Primer nombre": "Primer nombre",
    "CashDesk Name": "CashDesk Name",
    "Hora": "Hora",
    "Usuario que lo creo": "Usuario que lo creo",
    "Tipo:": "Tipo:",
    "Descripción:": "Descripción:",
    "Valor:": "Valor:",
    "Ingreso por tarjeta de crédito añadido satisfactoriamente": "Ingreso por tarjeta de crédito añadido satisfactoriamente",
    "Seleccione tipo de factura": "Seleccione tipo de factura",
    "POS": "POS",
    "CARTA": "CARTA",
    "Nro. Documento": "Nro. Documento",
    "Proveedor Tercero": "Proveedor Tercero",
    "Concepto:": "Concepto:",
    "Nro. Documento:": "Nro. Documento:",
    "Proveedores Terceros": "Proveedores Terceros",
    "Error, comuniquese con soporte. ": "Error, comuniquese con soporte. ",
    "Egreso añadido satisfactoriamente": "Egreso añadido satisfactoriamente",
    "Proveedor Tercero:": "Proveedor Tercero:",
    "Ingreso añadido satisfactoriamente": "Ingreso añadido satisfactoriamente",
    "Dinero Inicial:": "Dinero Inicial:",
    "Total Ingresos:": "Total Ingresos:",
    "Total Egresos:": "Total Egresos:",
    "Ingresos Tarjeta Credito:": "Ingresos Tarjeta Credito:",
    "Verifique que todos los datos sean validos ": "Verifique que todos los datos sean validos ",
    "Forma Pago 1": "Forma Pago 1",
    "Pago Bono / T.C.": "Pago Bono / T.C.",
    "Valor Entradas Efectivo": "Valor Entradas Efectivo",
    "Valor Entradas Bono / T.C.": "Valor Entradas Bono / T.C.",
    "Valor Entradas Traslados": "Valor Entradas Traslados",
    "Valor Entradas Recargas": "Valor Entradas Recargas",
    "Valor Salidas Efectivo": "Valor Salidas Efectivo",
    "Valor Salidas Traslados": "Valor Salidas Traslados",
    "Valor Salidas Notas de Retiro": "Valor Salidas Notas de Retiro",
    "V.Entradas Efectivo": "V.Entradas Efectivo",
    "V.Entradas Efectivo Neto": "V.Entradas Efectivo Neto",
    "V.Entradas Bono/T.C": "V.Entradas Bono/T.C",
    "V.Entradas Traslados": "V.Entradas Traslados",
    "V.Entradas Recargas": "V.Entradas Recargas",
    "V.Salidas Efectivo": "V.Salidas Efectivo",
    "V.Salidas Efectivo Neto": "V.Salidas Efectivo Neto",
    "V.Salidas Traslados": "V.Salidas Traslados",
    "V.Salidas N.Retiro": "V.Salidas N.Retiro",
    "Saldo": "Saldo",
    "Pagada?": "Pagada?",
    "Numero del cliente:": "Numero del cliente:",
    "Cedula del cliente:": "Cedula del cliente:",
    "Email del cliente:": "Email del cliente:",
    "Campo No Valido": "Campo No Valido",
    "Filtre Mínimo por un campo": "Filtre Mínimo por un campo",
    "Nro. de Cliente:": "Nro. de Cliente:",
    "Nombre del Cliente:": "Nombre del Cliente:",
    "País:": "País:",
    "Moneda:": "Moneda:",
    "Valor a Recargar:": "Valor a Recargar:",
    "Desea Realizar la Recarga?": "Desea Realizar la Recarga?",
    "Ocurrio un error...": "Ocurrio un error...",
    "Recarga Completada Satisfactoriamente": "Recarga Completada Satisfactoriamente",
    "Añadir Competidor": "Añadir Competidor",
    "Competidores": "Competidores",
    "Competidor Agregado": "Competidor Agregado",
    "Editar Competidor": "Editar Competidor",
    "Competidor Editado": "Competidor Editado",
    "Fecha de creación:": "Fecha de creación:",
    "Nombre de Usuario:": "Nombre de Usuario:",
    "Valor de la nota:": "Valor de la nota:",
    "Eliminar Nota": "Eliminar Nota",
    "ID Nota de Retiro:": "ID Nota de Retiro:",
    "Observaciones:": "Observaciones:",
    "Nro Nota Retiro:": "Nro Nota Retiro:",
    "Nro Usuario:": "Nro Usuario:",
    "Fecha Eliminación": "Fecha Eliminación",
    "Nombre del Usuario:": "Nombre del Usuario:",
    "Usuario que la Eliminó:": "Usuario que la Eliminó:",
    "Fecha Nota": "Fecha Nota",
    "Nro Nota Retiro": "Nro Nota Retiro",
    "Valor Nota": "Valor Nota",
    "Observaciones": "Observaciones",
    "Historial de gestiones": "Historial de gestiones",
    "Fecha/hora": "Fecha/hora",
    "Texto": "Texto",
    "Nota Generada": "Nota Generada",
    "Nombres:": "Nombres:",
    "Apellidos:": "Apellidos:",
    "Teléfono:": "Teléfono:",
    "Skype:": "Skype:",
    "Dirección:": "Dirección:",
    "Email:": "Email:",
    "Empresa:": "Empresa:",
    "Empresa": "Empresa",
    "Provincia": "Provincia",
    "Observacion": "Observacion",
    "Fecha/Hora Ultima Modif": "Fecha/Hora Ultima Modif",
    "Usuario Ultima Modif": "Usuario Ultima Modif",
    "Desea Terminar Gestión?": "Desea Terminar Gestión?",
    "Terminar Gestión": "Terminar Gestión",
    "Gestión Terminada satisfactoriamente. ": "Gestión Terminada satisfactoriamente. ",
    "Cedula de Ciudadania": "Cedula de Ciudadania",
    "Cedula de Extranjeria": "Cedula de Extranjeria",
    "Primer Nombre:": "Primer Nombre:",
    "Nro Documento:": "Nro Documento:",
    "Segundo Nombre:": "Segundo Nombre:",
    "Segundo Nombre": "Segundo Nombre",
    "Primer Apellido:": "Primer Apellido:",
    "Primer Apellido": "Primer Apellido",
    "Segundo Apellido:": "Segundo Apellido:",
    "Segundo Apellido": "Segundo Apellido",
    "Nro Cheque:": "Nro Cheque:",
    "Nro Cheque": "Nro Cheque",
    "Origen": "Origen",
    "Nota Retiro": "Nota Retiro",
    "Ticket": "Ticket",
    "Cliente:": "Cliente:",
    "Cliente": "Cliente",
    "Documento Referente:": "Documento Referente:",
    "Documento Referente": "Documento Referente",
    "Doc. Cliente:": "Doc. Cliente:",
    "Doc. Cliente": "Doc. Cliente",
    "Nro. Recarga:": "Nro. Recarga:",
    "Nro. Recarga": "Nro. Recarga",
    "Nro. Cliente:": "Nro. Cliente:",
    "Nro. Cliente": "Nro. Cliente",
    "Nombre Cliente:": "Nombre Cliente:",
    "Nombre Cliente": "Nombre Cliente",
    "Usuario Solicita": "Usuario Solicita",
    "Campo": "Campo",
    "Antiguo": "Antiguo",
    "Nuevo": "Nuevo",
    "Aprobadas": "Aprobadas",
    "Rechazadas": "Rechazadas",
    "Desea Rechazar el log?": "Desea Rechazar el log?",
    "Rechazar log": "Rechazar log",
    "Estado de log actualizado": "Estado de log actualizado",
    "Desea Aprobar el log?": "Desea Aprobar el log?",
    "UserName": "UserName",
    "Listo": "Listo",
    "Aprobada": "Aprobada",
    "Tipo de usuario": "Tipo de usuario",
    "Administrador General": "Administrador General",
    "Administrador Secundario": "Administrador Secundario",
    "Operador": "Operador",
    "System Administrator": "System Administrator",
    "Consultas": "Consultas",
    "ADMIN AFILIADOS": "ADMIN AFILIADOS",
    "CUSTOM": "CUSTOM",
    "Usuario de País": "Usuario de País",
    "Categoría cliente": "Categoría cliente",
    "Añadir Usuario": "Añadir Usuario",
    "Numero de Documento": "Numero de Documento",
    "Género": "Género",
    "Cumpleaños": "Cumpleaños",
    "Está bloqueado?": "Está bloqueado?",
    "País Residencia": "País Residencia",
    "Provincia/Región Residencia": "Provincia/Región Residencia",
    "Ciudad Residencia": "Ciudad Residencia",
    "Código Zip": "Código Zip",
    "Celular": "Celular",
    "Fecha de registro": "Fecha de registro",
    "Perfil": "Perfil",
    "Página": "Página",
    "DíasCaducidadClave": "DíasCaducidadClave",
    "Menus no permitidos": "Menus no permitidos",
    "Menus Permitidos": "Menus Permitidos",
    "ADMIN": "ADMIN",
    "ADMIN2": "ADMIN2",
    "ADMIN AGGREGATOR": "ADMIN AGGREGATOR",
    "CAJERO": "CAJERO",
    "CONCESIONARIO": "CONCESIONARIO",
    "CONCESIONARIO2": "CONCESIONARIO2",
    "OPERADOR": "OPERADOR",
    "PUNTOVENTA": "PUNTOVENTA",
    "CONSULTAS": "CONSULTAS",
    "ADMINAFILIADOS": "ADMINAFILIADOS",
    "Debe de seleccionar un usuario.": "Debe de seleccionar un usuario.",
    "Menu": "Menu",
    "Submenu": "Submenu",
    "Adicionar": "Adicionar",
    "Cedula Nacional": "Cedula Nacional",
    "Cedula Extranjera": "Cedula Extranjera",
    "Trabajador": "Trabajador",
    "Familiar Trabajador": "Familiar Trabajador",
    "Añadir Usuario a Bloquear": "Añadir Usuario a Bloquear",
    "Usuario Asociado": "Usuario Asociado",
    "Regional": "Regional",
    "Tipo Punto": "Tipo Punto",
    "Partners": "Partners",
    "Recargar Credito": "Recargar Credito",


    "Torneos y Bonos": "Torneos y Bonos",
    "Mi Configuracion": "Mi Configuracion",
    "Partners Proveedores": "Partners Proveedores",
    "Partners Tipo Producto": "Partners Tipo",
    "Partners Productos": "Partners Productos",
    "Partners Productos Pais": "Partners Productos Pais",
    "Categorias": "Categorias",
    "Categorías Productos": "Categorías Productos",
    "Jugadores": "Jugadores",
    "Jugadores Partner": "Jugadores Partner",
    "Jugadores Aggregator": "Jugadores Aggregator",
    "Reporte de depósitos": "Reporte de depósitos",
    "Autoexclusiones de Usuario": "Autoexclusiones de Usuario",
    "Reporte de casino": "Reporte productos no deportivos",
    "Reporte de Saldos": "Reporte de Saldos",
    "Reporte de bonos": "Reporte de bonos",
    "Reporte de Jugadores": "Reporte de Jugadores",
    "Flujo de Caja Histórico": "Flujo de Caja Histórico",
    "Flujo de Caja Resumido": "Flujo de Caja Resumido",
    "Informe Gerencial": "Informe Gerencial",
    "Usuario online Resumido": "Usuario online Resumido",
    "Usuario - Agregator": "Usuario - Agregator",
    "Premios pendientes por pagar": "Premios pendientes por pagar",
    "Reporte de Sesiones": "Reporte de Sesiones",
    "Reporte de Ajustes de Saldos": "Reporte de Ajustes de Saldos",
    "Reporte Trans. Sportbook": "Reporte Trans. Sportbook",
    "Reporte de  Movimientos Saldo": "Reporte de  Movimientos Saldo",
    "Historico de  Saldos": "Historico de  Saldos",
    "Documentos Registrados": "Documentos Registrados",
    "Contabilidad": "Contabilidad",
    "Centros de costo": "Centros de costo",
    "Estructural": "Estructural",
    "Cuentas": "Cuentas",
    "Cierres de Caja": "Cierres de Caja",
    "Seguridad": "Seguridad",
    "Aprobar logs": "Aprobar logs",
    "Usuarios administrativos": "Usuarios administrativos",
    "Usuarios Bloqueados": "Usuarios Bloqueados",
    "Contingencia": "Contingencia",
    "Menus": "Menus",
    "Perfiles": "Perfiles",
    "Perfiles - Options": "Perfiles - Options",
    "Sub Menu": "Sub Menu",
    "Usuario Perfil": "Usuario Perfil",
    "Gestion": "Gestion",
    "Codigos Promocionales": "Codigos Promocionales",
    "Activar Registros": "Activar Registros",
    "Ajustar pasarela de pago": "Ajustar pasarela de pago",
    "Asignacion de cupo": "Asignacion de cupo",
    "Eliminar nota de retiro": "Eliminar nota de retiro",
    "Manejar red": "Manejar red",
    "Registro rapido": "Registro rapido",
    "Reimprimir cheque": "Reimprimir cheque",
    "Reversion": "Reversion",
    "Trabaja con nosotros": "Trabaja con nosotros",
    "Caja": "Caja",
    "Pago Premio": "Pago Premio",
    "Pago Nota Retiro": "Pago Nota Retiro",
    "Lista": "Lista",
    "Maquinas": "Maquinas",
    "Registrar": "Registrar",
    "Pago Nota de cobro": "Pago Nota de cobro",
    "Maquinas Grafica": "Maquinas Grafica",
    "Herramientas": "Herramientas",
    "Partner Ajustes": "Partner Ajustes",
    "Traducción": "Traducción",
    "Subir imagen": "Subir imagen",
    "Gestión Punto de Venta": "Gestión Punto de Venta",
    "Gestión Puntos Gráfico": "Gestión Puntos Gráfico",
    "Puntos de venta Competencia": "Puntos de venta Competencia",
    "Agentes": "Agentes",
    "Lista de Agentes": "Lista de Agentes",
    "Árbol de Agentes": "Árbol de Agentes",
    "Informe de Agentes": "Informe de Agentes",
    "Transferencias": "Transferencias",
    "Solicitudes": "Solicitudes",
    "Solicitudes de Retiro": "Solicitudes de Retiro",
    "Solicitudes de Deposito": "Solicitudes de Deposito",
    "Cierre de caja": "Cierre de caja",

    "Inicio Día": "Inicio Día",
    "Fecha: ": "Fecha: ",
    "Valor Inicio de día:": "Valor Inicio de día:",

    "Agregar imagen": "Agregar imagen",
    "Añadir Proveedor Partner": "Añadir Proveedor Partner",
    "Proveedor Partner": "Proveedor Partner",
    "Tipo Producto Partner": "Tipo Producto Partner",
    "Saldo Depósitos:": "Saldo Depósitos:",
    "Tipo de integración": "Tipo de integración",
    "Pasarela de Pagos": "Pasarela de Pagos",
    "Lobby con token propio": "Lobby con token propio",
    "Lobby con token de proveedor": "Lobby con token de proveedor",
    "Productos Partner": "Productos Partner",
    "Automático": "Automático",
    "Partners Productos País": "Partners Productos País",
    "Lista de Jugadores": "Lista de Jugadores",
    "Bloqueados": "Bloqueados",
    "DNI Anterior": "DNI Anterior",
    "No tiene DNI Anterior": "No tiene DNI Anterior",
    "DNI Posterior": "DNI Posterior",
    "No tiene DNI Posterior": "No tiene DNI Posterior",
    "Descargar": "Descargar",
    "Tipo de Documento": "Tipo de Documento",
    "Cedula de Extranjería": "Cedula de Extranjería",
    "Subir DNI Anterior": "Subir DNI Anterior",
    "Subir DNI Posterior": "Subir DNI Posterior",
    "Finanzas": "Finanzas",
    "Resumen": "Resumen",
    "Reporte Autoexclusión": "Reporte Autoexclusión",
    "Reporte de Sesiones": "Reporte de Sesiones",
    "Registro de Documentos": "Registro de Documentos",
    "Ver más": "Ver más",
    "Historial de saldo": "Historial de saldo",
    "Historial de movimientos": "Historial de movimientos",
    "Logs Usuario": "Logs Usuario",
    "Valor Mínimo": "Valor Mínimo",
    "Valor Máximo": "Valor Máximo",
    "Premio Total Máximo":"Premio Total Máximo",
    "Premio Total Mínimo":"Premio Total Mínimo",
    "Crear Token Personalizado": "Crear Token Personalizado",
    "Crear Token": "Crear Token",
    "Token": "Token",
    "Token Creado": "Token Creado",
    "Cancelar Cuenta": "Cancelar Cuenta",
    "Desea cancelar la cuenta de el usuario?": "Desea cancelar la cuenta de el usuario?",
    "Resumen por Proveedor": "Resumen por Proveedor",
    "Tipo Pasarela de Pago": "Tipo Pasarela de Pago",
    "Proveedor pasarela de pago": "Proveedor pasarela de pago",
    "Usuarios Autoexcluidos": "Usuarios Autoexcluidos",
    "Cantidad": "Cantidad",
    "Saldo Gratis": "Saldo Gratis",
    "Envió": "Envió",
    "Reporte de Saldos Online": "Reporte de Saldos Online",
    "Añadir bono a saldo": "Añadir bono a saldo",
    "Bono a saldo añadido correctamente": "Bono a saldo añadido correctamente",
    "Tipo de Detalle": "Tipo de Detalle",
    "Apuesta": "Apuesta",
    "Apuesta Promedio": "Apuesta Promedio",
    "Usuarios Registrados": "Usuarios Registrados",
    "Primeros Depósitos": "Primeros Depósitos",
    "Usuario Id": "Usuario Id",
    "Cant Tickets Casino": "Cant Tickets Casino",
    "Cant Tickets Casino Vivo": "Cant Tickets Casino Vivo",
    "Total Tickets": "Total Tickets",
    "Saldo Disp Retiro": "Saldo Disp Retiro",
    "Nota de retiro pendiente": "Nota de retiro pendiente",
    "Vlr Ap. Casino": "Vlr Ap. Casino",
    "Vlr Ap. Casino Vivo": "Vlr Ap. Casino Vivo",
    "Total Apostado": "Total Apostado",
    "Vlr Pr. Casino": "Vlr Pr. Casino",
    "Vlr Pr. Casino Vivo": "Vlr Pr. Casino Vivo",
    "Total premios": "Total premios",
    "Saldo Recargas": "Saldo Recargas",
    "Valor Recargas": "Valor Recargas",
    "Valor premios": "Valor premios",
    "Relación Usuario Aggregato": "Relación Usuario Aggregato",
    "Usuario Partner": "Usuario Partner",
    "Usuario Aggregator": "User Aggregator",
    "Añadir Relación": "Añadir Relación",
    "Editar Relación": "Editar Relación",
    "Hora de creación": "Hora de creación",
    "Fecha Premio": "Fecha Premio",
    "Hora Premio": "Hora Premio",
    "Transacciones deportivas": "Transacciones deportivas",
    "Saldo Inicial": "Saldo Inicial",
    "Ap. Deportivas": "Ap. Deportivas",
    "Pr. Deportivas": "Pr. Deportivas",
    "Ap. Casino": "Ap. Casino",
    "Pr. Casino": "Pr. Casino",
    "Retiros Creados": "Retiros Creados",
    "Retiros Eliminados": "Retiros Eliminados",
    "Ajustes E": "Ajustes E",
    "Ajustes S": "Ajustes S",
    "Saldo Final": "Saldo Final",
    "Saldo Final Calc.": "Saldo Final Calc.",
    "Retiros Pagados": "Retiros Pagados",
    "Retiros Pendientes": "Retiros Pendientes",
    "Bonos Free Ganados": "Bonos Free Ganados",
    "Añadir Documento": "Añadir Documento",
    "Editar Documento": "Editar Documento",
    "Puntos de Venta": "Puntos de Venta",
    "Saldo Juego": "Saldo Juego",
    "Datos Punto de venta": "Datos Punto de venta",
    "Configuración Punto de Venta": "Configuración Punto de Venta",
    "Contraseña": "Contraseña",
    "Forma de pago": "Forma de pago",
    "Modificó": "Modificó",
    "Nombre del sistema de pasarela de pago": "Nombre del sistema de pasarela de pago",
    "Tipo de tiempo": "Tipo de tiempo",
    "Resultado": "Resultado",
    "Fecha Resultado": "Fecha Resultado",
    "Reporte Flujo de Caja": "Reporte Flujo de Caja",
    "Rollover Apostado": "Rollover Apostado",
    "Rollover Restante": "Rollover Restante",
    "Estado de Recarga": "Estado de Recarga",
    "Actualizar IP": "Actualizar IP",
    "Punto de Venta:": "Punto de Venta:",
    "ID Sesión": "ID Sesión",
    "Tipo de Cierre": "Tipo de Cierre",
    "Sistema": "Sistema",
    "Hora Fin": "Hora Fin",
    "Geolocalización": "Geolocalización",
    "Monto Apostado": "Monto Apostado",
    "Créditos Promocionales Recibidos": "Créditos Promocionales Recibidos",
    "Créditos Promocionales Apostados": "Créditos Promocionales Apostados",
    "Motivo Cierre": "Motivo Cierre",
    "Saldo al Iniciar": "Saldo al Iniciar",
    "Saldo al Final": "Saldo al Final",
    "Monto Ganado": "Monto Ganado",
    "Sistema operativo": "Sistema operativo",
    "Inicio de sesión fallidos": "Inicio de sesión fallidos",
    "Cambio realizado a la cuenta": "Cambio realizado a la cuenta",
    "Cuenta cancelada": "Cuenta cancelada",
    "Arrastra Negativos": "Arrastra Negativos",
    "Estadísticas": "Estadísticas",
    "Estadisticas": "Estadisticas",
    "Añadir Agente:": "Añadir Agente:",
    "Eliminado": "Eliminado",
    "Devueltas": "Devueltas",
    "Añadir Código": "Añadir Código",
    "Editar Código": "Editar Código",
    "Visitas Links": "Visitas Links",
    "Registros": "Registros",
    "Edad": "Edad",
    "Informe Red": "Informe Red",
    "Realizar Transferencia": "Realizar Transferencia",
    "Apellidos": "Apellidos",
    "Productos Terceros ": "Productos Terceros ",
    "Depositos": "Depositos",
    "JUGADORES ACTIVOS": "JUGADORES ACTIVOS",
    "APUESTAS": "APUESTAS",
    "PREMIOS PAGADOS": "PREMIOS PAGADOS",
    "Aprobación Logs": "Aprobación Logs",
    "Aprobar log": "Aprobar log",
    "Administración de Usuarios": "Administración de Usuarios",
    "Administración de Usuarios Bloqueados": "Administración de Usuarios Bloqueados",
    "Usuario:": "Usuario:",
    "Usuario es de País": "Usuario es de País",
    "Usuario es Global": "Usuario es Global",
    "Activar Usuario País": "Activar Usuario País",
    "Inactivar Usuario País": "Inactivar Usuario País",
    "Añadir Usuario:": "Añadir Usuario:",
    "Perfil Opciones": "Perfil Opciones",
    "Códigos promocionales": "Códigos promocionales",
    "Función": "Función",
    "Registro": "Registro",
    "Activar Registro": "Activar Registro",
    "Gestión Contacto": "Gestión Contacto",
    "Fecha/Hora Creación": "Fecha/Hora Creación",
    "Nombres": "Nombres",
    "Crear Nota": "Crear Nota",
    "Terminado": "Terminado",
    "Pago Nota de Retiro": "Pago Nota de Retiro",
    "Máquinas": "Máquinas",
    "Añadir Máquina": "Añadir Máquina",
    "Añadir Máquina:": "Añadir Máquina:",
    "Teléfono Mobile": "Teléfono Mobile",
    "Recargar Máquina ": "Recargar Máquina ",
    "Actualizar Máquina": "Actualizar Máquina",
    "Actualizar Versión": "Actualizar Versión",
    "Actualizar Máquina ": "Actualizar Máquina ",
    "Publicidad": "Publicidad",
    "Estado de Máquina": "Estado de Máquina",
    "Pago Nota de Cobro": "Pago Nota de Cobro",
    "Máquinas Grafica": "Máquinas Grafica",
    "Solicitud de retiro de clientes": "Solicitud de retiro de clientes",
    "Solicitud de depósito de clientes": "Solicitud de depósito de clientes",
    "Ajustes Generales": "Ajustes Generales",
    "Nombre Compañía": "Nombre Compañía",
    "Días de expiración de la contraseña": "Días de expiración de la contraseña",
    "Regular Expresión contraseña usuario": "Regular Expresión contraseña usuario",
    "Días de expiración contraseña temporal": "Días de expiración contraseña temporal",
    "Mínima longitud de la contraseña": "Mínima longitud de la contraseña",
    "Días antes de notificación de expiración": "Días antes de notificación de expiración",
    "Expresión regular que valide una contraseña. ": "Expresión regular que valide una contraseña. ",
    "Ej: Que tenga entre 4 y 16 caracteres.": "Ej: Que tenga entre 4 y 16 caracteres.",
    "Cuantos días antes de que expire la contraseña, se le notificara el cambio": "Cuantos días antes de que expire la contraseña, se le notificara el cambio",
    "Máximo solicitudes por día": "Máximo solicitudes por día",
    "Porcentaje mínimo apostado/depositado": "Porcentaje mínimo apostado/depositado",
    "Porcentaje mínimo apostado sobre lo depositado": "Porcentaje mínimo apostado sobre lo depositado",
    "Especifique el porcentaje mínimo apostado sobre lo depositado.": "Especifique el porcentaje mínimo apostado sobre lo depositado.",
    "Mínimo monto en solicitud de retiro": "Mínimo monto en solicitud de retiro",
    "Máximo monto en solicitud de retiro": "Máximo monto en solicitud de retiro",
    "Máxima cantidad de solicitudes activas": "Máxima cantidad de solicitudes activas",
    "Mínimo monto de solicitud de deposito": "Mínimo monto de solicitud de deposito",
    "Máximo monto de solicitud de deposito": "Máximo monto de solicitud de deposito",
    "Impuesto Retiro Saldo Deposito": "Impuesto Retiro Saldo Deposito",
    "Impuesto Retiro Saldo Premios a partir de": "Impuesto Retiro Saldo Premios a partir de",
    "Impuesto por Retiro Saldo Premios a partir de un valor.": "Impuesto por Retiro Saldo Premios a partir de un valor.",
    "Aprobar cuentas bancarias?": "Aprobar cuentas bancarias?",
    "Porcentaje Penalidad Retiro Saldo Retiros": "Porcentaje Penalidad Retiro Saldo Retiros",
    "Especifique el porcentaje de la penalidad por retiro a saldo de retiros.": "Especifique el porcentaje de la penalidad por retiro a saldo de retiros.",
    "Días para alerta de actualización de datos": "Días para alerta de actualización de datos",
    "Días para alerta de actualización de datos del usuario.": "Días para alerta de actualización de datos del usuario.",
    "Impuesto Retiro Saldo Premios": "Impuesto Retiro Saldo Premios",
    "Impuesto al ente regulador a partir de": "Impuesto al ente regulador a partir de",
    "Aprobar cambios de información personal?": "Aprobar cambios de información personal?",
    "Aprobar los cambios de información personal hechos por el usuario?": "Aprobar los cambios de información personal hechos por el usuario?",
    "Mínimo Retiro de Saldo Retiros para Penalizar": "Mínimo Retiro de Saldo Retiros para Penalizar",
    "Especifique el monto mínimo de retiro de saldo retiros para penalizar.": "Especifique el monto mínimo de retiro de saldo retiros para penalizar.",
    "Días para alerta de cambio de contraseña": "Días para alerta de cambio de contraseña",
    "Impuesto al ente regulador": "Impuesto al ente regulador",
    "Impuesto premios por punto de venta físico": "Impuesto premios por punto de venta físico",
    "Impuesto a los premios reclamados por punto de venta físico": "Impuesto a los premios reclamados por punto de venta físico",
    "Máximo cuentas bancarias": "Máximo cuentas bancarias",
    "Porcentaje Penalidad Retiro Saldo Recargas": "Porcentaje Penalidad Retiro Saldo Recargas",
    "Especifique el porcentaje de la penalidad por retiro a saldo de recargas.": "Especifique el porcentaje de la penalidad por retiro a saldo de recargas.",
    "Porcentaje Invalido": "Porcentaje Invalido",
    "Inactividad de sesión en minutos": "Inactividad de sesión en minutos",
    "Establezca el tiempo de inactividad en minutos para el cierre de sesión.": "Establezca el tiempo de inactividad en minutos para el cierre de sesión.",
    "Duración de la sesión en minutos": "Duración de la sesión en minutos",
    "Establezca la duración de la sesión de juego en minutos.": "Establezca la duración de la sesión de juego en minutos.",
    "URL fondo casino": "URL fondo casino",
    "Establezca la URL de la imagen para fondo de casino.": "Establezca la URL de la imagen para fondo de casino.",
    "Impuesto Retiro Saldo Deposito a partir de": "Impuesto Retiro Saldo Deposito a partir de",
    "Impuesto por Retiro Saldo Deposito a partir de un valor": "Impuesto por Retiro Saldo Deposito a partir de un valor",
    "Requiere registro activo para iniciar sesión?": "Requiere registro activo para iniciar sesión?",
    "Mínimo Retiro de Recargas para Penalizar": "Mínimo Retiro de Recargas para Penalizar",
    "Especifique el monto mínimo de retiro de saldo recargas para penalizar.": "Especifique el monto mínimo de retiro de saldo recargas para penalizar.",
    "Liquidaciones generadas": "Liquidaciones generadas",
    "Contigencia Total": "Contigencia Total",
    "Automáticas": "Automáticas",
    "Manuales": "Manuales",
    "Informacíon Actualizada": "Informacíon Actualizada",
    "Días de expiración de la contraseña temporal": "Días de expiración de la contraseña temporal",
    "Solicitudes de Depósitos": "Solicitudes de Depósitos",
    "Recepción de Efectivo": "Recepción de Efectivo",
    "Aprobar Depósito": "Aprobar Depósito",
    "Rechazar Depósito": "Rechazar Depósito",
    "Método de pago cuentas bancarias": "Método de pago cuentas bancarias",
    "Pagado físicamente": "Pagado físicamente",
    "Pagado por sistema": "Pagado por sistema",
    "Método de pago": "Método de pago",
    "Aprobar Nota": "Aprobar Nota",
    "Desea Aprobar Nota de Retiro?": "Desea Aprobar Nota de Retiro?",
    "Rechazar Nota": "Rechazar Nota",
    "Desea Rechazar Nota de Retiro?": "Desea Rechazar Nota de Retiro?",
    "Ver por un cajero en especifico": "Ver por un cajero en especifico",
    "Volver": "Volver",
    "Ingresos Tarjetas de crédito": "Ingresos Tarjetas de crédito",
    "Otros Egresos": "Otros Egresos",
    "Añadir ingreso por tarjeta": "Añadir ingreso por tarjeta",
    "Cerrar día": "Cerrar día",
    "No hay datos": "No hay datos",
    "Especifique si el usuario quedara automáticamente activado después del registro": "Especifique si el usuario quedara automáticamente activado después del registro",
    "Usuario automáticamente activado": "Usuario automáticamente activado",
    "Limite depósito día por defecto": "Limite depósito día por defecto",
    "Especifique el límite de depósito diario por defecto": "Especifique el límite de depósito diario por defecto",
    "Limite depósito semana por defecto": "Limite depósito semana por defecto",
    "Especifique el límite de depósito semanal por defecto": "Especifique el límite de depósito semanal por defecto",
    "Limite depósito mes por defecto": "Limite depósito mes por defecto",
    "Especifique el límite de depósito mensual por defecto": "Especifique el límite de depósito mensual por defecto",
    "Limite depósito día global": "Limite depósito día global",
    "Especifique el límite de depósito diario global": "Especifique el límite de depósito diario global",
    "Limite depósito semana global": "Limite depósito semana global",
    "Especifique el límite de depósito semanal global": "Especifique el límite de depósito semanal global",
    "Limite depósito mes global": "Limite depósito mes global",
    "Especifique el límite de depósito mensual global": "Especifique el límite de depósito mensual global",
    "Máximo intentos inicio sesión": "Máximo intentos inicio sesión",
    "Especifique el número máximo de intentos para iniciar sesión": "Especifique el número máximo de intentos para iniciar sesión",
    "Mínimo retiros punto": "Mínimo retiros punto",
    "Mínimo monto en solicitud de retiro por punto de venta": "Mínimo monto en solicitud de retiro por punto de venta",
    "Competidor": "Competidor",
    "Desea cancelar la cuenta del punto de venta?": "Desea cancelar la cuenta del punto de venta?",
    "Fecha Pagado": "Fecha Pagado",
    "Tipo de cuenta": "Tipo de cuenta",
    "Configuración Partner": "Configuración Partner",
    "No tienes un QR Configurado, por favor comunicarse con soporte.": "No tienes un QR Configurado, por favor comunicarse con soporte.",
    "30003": "El usuario o la clave son incorrectos.",
    "Zona horaria:": "Zona horaria:",
    "Moneda para reportes": "Moneda para reportes",
    "Impuesto sobre apuesta al pagar premio": "Impuesto sobre apuesta al pagar premio",
    "Impuesto sobre el monto de la apuesta al momento de pagar el premio": "Impuesto sobre el monto de la apuesta al momento de pagar el premio",
    "Verificó DNI posterior?": "Verificó DNI posterior?",
    "Verificó DNI anterior?": "Verificó DNI anterior?",
    "Tipo de liquidaciones comisiones": "Tipo de liquidaciones comisiones",
    "Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.": "Especifique el tipo de liquidaciones para las comisiones, sea por caja o por cierre.",
    "Cierre": "Cierre",
    "Cierre Pagada": "Cierre Pagada",
    "El usuario o la clave son incorrectos.  (Report#30003)": "El usuario o la clave son incorrectos.  (Report#30003)",
    "Total Caja:": "Total Caja:",
    "Se cerró el día satisfactoriamente": "Se cerró el día satisfactoriamente",
    "Ya se efectuó el cierre de día, nos es posible realizar esta operación": "Ya se efectuó el cierre de día, nos es posible realizar esta operación",
    "Ticket Ganador": "Ticket Ganador",
    "Ticket Perdedor": "Ticket Perdedor",
    "Ticket Pendiente": "Ticket Pendiente",
    "Premio Pagado": "Premio Pagado",
    "Ticket no encontrado":"Ticket no encontrado",
    "Nota de retiro no encontrada":"Nota de retiro no encontrada",
    "Nota de retiro pagada":"Nota de retiro pagada",
    "Confirmar Valor:":"Confirmar Valor:",
    "Confirmar Valor":"Confirmar Valor",
    "Valores no coinciden":"Valores no coinciden",
    "Ya se efectuó el cierre de día, no es posible realizar esta operación":"Ya se efectuó el cierre de día, no es posible realizar esta operación",
    "Apuestas Deportivas":"Apuestas Deportivas",
    "Apuestas deportivas en vivo":"Apuestas deportivas en vivo",
    "Apuestas Virtuales":"Apuestas Virtuales",
    "El usuario no se encuentra o ya fue activado":"El usuario no se encuentra o ya fue activado",
    "Premio pagado satisfactoriamente":"Premio pagado satisfactoriamente",
    "ID Afiliador":"ID Afiliador",
    "Nombre Afiliador":"Nombre Afiliador",
    "Recargas Eliminadas":"Recargas Eliminadas",
    "Cupo Recarga E":"Cupo Recarga E",
    "Cupo Recarga S":"Cupo Recarga S",
    "Cupo recargas inicial":"Cupo recargas inicial",
    "Cupo juego inicial":"Cupo juego inicial",
    "Cupo recargas final":"Cupo recargas final",
    "Cupo recargas final Calc.":"Cupo recargas final Calc.",
    "Cupo juego final":"Cupo juego final",
    "Cupo juego final Calc.":"Cupo juego final Calc.",
    "Historial de saldo punto de venta":"Historial de saldo punto de venta",
    "Cupo Apuesta E":"Cupo Apuesta E",
    "Cupo Apuesta S":"Cupo Apuesta S",
    "Punto de venta propio?":"Punto de venta propio?",
    "Tipos de documentos":"Tipos de documentos",
    "Tipo de documento agregado":"Tipo de documento agregado",
    "Tipo de documento actualizado":"Tipo de documento actualizado",
    "Añadir tipo de documento":"Añadir tipo de documento",
    "Editar tipo de documento":"Editar tipo de documento",
    "Serie:":"Serie:",
    "Tipo documento:":"Tipo documento:",
    "Impuesto:":"Impuesto:",
    "Saldo Antes de Ajuste":"Saldo Antes de Ajuste",
    "Saldo Despues de Ajuste":"Saldo Despues de Ajuste",
    "Numero Autoexclusiónes":"Numero Autoexclusiónes",
    "Motivo Autoexclusión":"Motivo Autoexclusión",
    "Fondos Depositados":"Fondos Depositados",
    "Fondos Retirados":"Fondos Retirados",
    "Fondos Restantes de Juegos Incompletos":"Fondos Restantes de Juegos Incompletos",
    "Requiere registro activo para depositar?":"Requiere registro activo para depositar?",
    "Especifique si el usuario necesita tener el registro activado para poder depositar":"Especifique si el usuario necesita tener el registro activado para poder depositar",
    "Requiere verificación de cuenta para depositar?":"Requiere verificación de cuenta para depositar?",
    "Especifique si el usuario necesita verificar cuenta para poder depositar":"Especifique si el usuario necesita verificar cuenta para poder depositar",
    "Requiere registro activo para retirar?":"Requiere registro activo para retirar?",
    "Especifique si el usuario necesita tener el registro activado para poder retirar":"Especifique si el usuario necesita tener el registro activado para poder retirar",
    "Requiere verificación de cuenta para retirar?":"Requiere verificación de cuenta para retirar?",
    "Especifique si el usuario necesita verificar cuenta para poder retirar":"Especifique si el usuario necesita verificar cuenta para poder retirar",
    "Tipo de comisión puntos de venta":"Tipo de comisión puntos de venta",
    "Especifique el tipo de comisión para los puntos de venta.":"Especifique el tipo de comisión para los puntos de venta.",
    "Logs Usuario General":"Logs Usuario General",
    "Ordenar por":"Ordenar por",
    "Orden":"Orden",
    "Ascendente":"Ascendente",
    "Descendente":"Descendente",
    "Cajero":"Cajero",
    "Historico Saldos Punto Venta":"Historico Saldos Punto Venta",
    "Reporte Comisiones Global":"Reporte Comisiones Global",
    "Desea cerrar día?":"Desea cerrar día?",
    "Impuestos":"Impuestos",
    "Fecha de exportación: ":"Fecha de exportación: ",
    "Confirme recarga de ":"Confirme recarga de ",
    " para el usuario ":" para el usuario ",
    "Tipo de Saldo":"Tipo de Saldo",
    "Saldo de Recargas":"Saldo de Recargas",
    "Continuar":"Continuar",
    "Reporte de Transferencias":"Reporte de Transferencias",
    "Usuario Creó":"Usuario Creó",
    "Usuario Recibió":"Usuario Recibió",
    "Fecha de reporte: Desde ":"Fecha de reporte: Desde ",
    " Hasta ":" Hasta ",
    "Desea Rechazar la Retracción de Saldo?":"Desea Rechazar la Retracción de Saldo?",
    "Estado de Retracción actualizado":"Estado de Retracción actualizado",
    "Desea Aprobar el Retracción de Saldo?":"Desea Aprobar el Retracción de Saldo?",
    "Estado de Retracción actualizado":"Estado de Retracción actualizado",
    "Aprobación de Retracción de Saldo":"Aprobación de Retracción de Saldo",
    "Te estas logueando desde el sitio equivocado.":"Te estas logueando desde el sitio equivocado.",
    "¡Serás redireccionado a tu sitio!":"¡Serás redireccionado a tu sitio!",
    "¡Atención!":"¡Atención!",
    "IR AL SITIO":"IR AL SITIO",
    "Punto Venta Pagó":"Punto Venta Pagó",
    "¿Es de movimiento de base de caja?":"¿Es de movimiento de base de caja?",
    "Centro de costo personalizado":"Centro de costo personalizado",
    "Apuestas Anuladas":"Apuestas Anuladas",
    "Apuestas Pagadas Anuladas":"Apuestas Pagadas Anuladas",
    "Estado Celular":"Estado Celular",
    "Sin verificar":"Sin verificar",
    "Descripción del reporte: Flujo Caja Resumido":"Descripción del reporte: Flujo Caja Resumido",
    "Fecha creación del reporte: ":"Fecha creación del reporte: ",
    "Flujo Caja Resumido":"Flujo Caja Resumido",
    "Sub Diario":"Sub Diario",
    "Número de Comprobante":"Número de Comprobante",
    "Fecha de Comprobante":"Fecha de Comprobante",
    "Código de Moneda":"Código de Moneda",
    "Glosa Principal":"Glosa Principal",
    "Tipo de Cambio":"Tipo de Cambio",
    "Tipo de Conversión":"Tipo de Conversión",
    "Flag de Conversión de Moneda":"Flag de Conversión de Moneda",
    "Fecha Tipo de Cambio":"Fecha Tipo de Cambio",
    "Cuenta Contable":"Cuenta Contable",
    "Código de Anexo":"Código de Anexo",
    "Código de Centro de Costo":"Código de Centro de Costo",
    "Debe / Haber":"Debe / Haber",
    "Importe Original":"Importe Original",
    "Importe en Dólares":"Importe en Dólares",
    "Importe en Soles":"Importe en Soles",
    "Tipo de Documento":"Tipo de Documento",
    "Número de Documento":"Número de Documento",
    "Fecha de Documento":"Fecha de Documento",
    "Fecha de Vencimiento":"Fecha de Vencimiento",
    "Código de Area":"Código de Area",
    "Glosa Detalle":"Glosa Detalle",
    "Código de Anexo Auxiliar":"Código de Anexo Auxiliar",
    "Medio de Pago":"Medio de Pago",
    "Tipo de Documento de Referencia":"Tipo de Documento de Referencia",
    "Número de Documento Referencia":"Número de Documento Referencia",
    "Fecha Documento Referencia":"Fecha Documento Referencia",
    "Nro Máq. Registradora Tipo Doc. Ref.":"Nro Máq. Registradora Tipo Doc. Ref.",
    "Base Imponible Documento Referencia":"Base Imponible Documento Referencia",
    "IGV Documento Provisión":"IGV Documento Provisión",
    "Tipo Referencia en estado MQ":"Tipo Referencia en estado MQ",
    "Número Serie Caja Registradora":"Número Serie Caja Registradora",
    "Fecha de Operación":"Fecha de Operación",
    "Tipo de Tasa":"Tipo de Tasa",
    "Tasa Detracción/Percepción":"Tasa Detracción/Percepción",
    "Importe Base Detracción/Percepción Dólares":"Importe Base Detracción/Percepción Dólares",
    "Importe Base Detracción/Percepción Soles":"Importe Base Detracción/Percepción Soles",
    "Tipo Cambio para F":"Tipo Cambio para F",
    "Importe de IGV sin derecho crédito fiscal":"Importe de IGV sin derecho crédito fiscal",
    "Ver T.G. 02":"Ver T.G. 02",
    "Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo":"Los dos primeros dígitos son el mes y los otros 4 siguientes un correlativo",
    "Ver T.G. 03":"Ver T.G. 03",
    "Llenar  solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999":"Llenar  solo si Tipo de Conversión es 'C'. Debe estar entre >=0 y <=9999.999999",
    "Solo: 'C'= Especial, 'M'=Compra, 'V'=Venta , 'F' De acuerdo a fecha":"Solo: 'C'= Especial, 'M'=Compra, 'V'=Venta , 'F' De acuerdo a fecha",
    "Solo: 'S' = Si se convierte, 'N'= No se convierte":"Solo: 'S' = Si se convierte, 'N'= No se convierte",
    "Si  Tipo de Conversión 'F'":"Si  Tipo de Conversión 'F'",
    "Debe existir en el Plan de Cuentas":"Debe existir en el Plan de Cuentas",
    "Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos":"Si Cuenta Contable tiene seleccionado Tipo de Anexo, debe existir en la tabla de Anexos",
    "Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05":"Si Cuenta Contable tiene habilitado C. Costo, Ver T.G. 05",
    "'D' ó 'H'":"'D' ó 'H'",
    "Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ":"Importe original de la cuenta contable. Obligatorio, debe estar entre >=0 y <=99999999999.99 ",
    "Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99 ":"Importe de la Cuenta Contable en Dólares. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estar entre >=0 y <=99999999999.99 ",
    "Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99 ":"Importe de la Cuenta Contable en Soles. Obligatorio si Flag de Conversión de Moneda esta en 'N', debe estra entre >=0 y <=99999999999.99 ",
    "Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06":"Si Cuenta Contable tiene habilitado el Documento Referencia Ver T.G. 06",
    "Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número":"Si Cuenta Contable tiene habilitado el Documento Referencia Incluye Serie y Número",
    "Si Cuenta Contable tiene habilitado el Documento Referencia":"Si Cuenta Contable tiene habilitado el Documento Referencia",
    "Si Cuenta Contable tiene habilitada la Fecha de Vencimiento":"Si Cuenta Contable tiene habilitada la Fecha de Vencimiento",
    "Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26":"Si Cuenta Contable tiene habilitada el Area. Ver T.G. 26",
    "Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia":"Si Cuenta Contable tiene seleccionado Tipo de Anexo Referencia",
    "Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'":"Si Cuenta Contable tiene habilitado Tipo Medio Pago. Ver T.G. 'S1'",
    "Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06":"Si Tipo de Documento es 'NA' ó 'ND' Ver T.G. 06",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND', incluye Serie y Número":"Si Tipo de Documento es 'NC', 'NA' ó 'ND', incluye Serie y Número",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'":"Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'":"Si Tipo de Documento es 'NC', 'NA' ó 'ND'. Solo cuando el Tipo Documento de Referencia 'TK'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'":"Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si Tipo de Documento es 'NC', 'NA' ó 'ND'":"Si Tipo de Documento es 'NC', 'NA' ó 'ND'",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'":"Si la Cuenta Contable tiene Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'",
    "Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'":"Si la Cuenta Contable teien Habilitado Documento Referencia 2 y  Tipo de Documento es 'TK'",
    "Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket":"Si la Cuenta Contable tiene Habilitado Documento Referencia 2. Cuando Tipo de Documento es 'TK', consignar la fecha de emision del ticket",
    "Si la Cuenta Contable tiene configurada la Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29":"Si la Cuenta Contable tiene configurada la Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29",
    "Si la Cuenta Contable tiene conf. en Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99":"Si la Cuenta Contable tiene conf. en Tasa:  Si es '1' ver T.G. 28 y '2' ver T.G. 29. Debe estar entre >=0 y <=999.99",
    "Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99":"Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99",
    "Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99":"Si la Cuenta Contable tiene configurada la Tasa. Debe ser el importe total del documento y estar entre >=0 y <=99999999999.99",
    "Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.":"Especificar solo si Tipo Conversión es 'F'. Se permite 'M' Compra y 'V' Venta.",
    "Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx":"Especificar solo para comprobantes de compras con IGV sin derecho de crédito Fiscal. Se detalle solo en la cuenta 42xxxx",
    "Exportación Masiva":"Exportación Masiva",
    "Cuenta de cancelación":"Cuenta de cancelación",
    "Estado de Contingencia Retiro":"Estado de Contingencia Retiro",
    "Estado de Contingencia Deposito":"Estado de Contingencia Deposito",
    "Estado Especial":"Estado Especial",
    "Proveedor de SMS":"Proveedor de SMS",
    "Proveedor de Email":"Proveedor de Email",
    "Cerrar día especifico":"Cerrar día especifico",
    "Descripción del reporte: Flujo Caja Resumido ":"Descripción del reporte: Flujo Caja Resumido ",
    " Fecha creación del reporte: ":" Fecha creación del reporte: ",
    "Serie":"Serie",
    "QR Copiado!":"QR Copiado!",
    "Enviar código al celular":"Enviar código al celular",
    "Código enviado":"Código enviado",
    "¿Producto tiene cupo?":"¿Producto tiene cupo?",
    "Productos terceros con cupo":"Productos terceros con cupo",
    "Agregar cupo":"Agregar cupo",
    "Cupo Agregado":"Cupo Agregado",
    "Ingreso editado satisfactoriamente":"Ingreso editado satisfactoriamente",
    "Editar Ingreso":"Editar Ingreso",
    "Editar Egreso":"Editar Egreso",
    "Egreso editado satisfactoriamente":"Egreso editado satisfactoriamente",
    "Ingreso por tarjeta de crédito editado satisfactoriamente":"Ingreso por tarjeta de crédito editado satisfactoriamente",
    "Identificador":"Identificador",
    "Enviar banner invasivo":"Enviar banner invasivo",
    "Banner invasivo enviado satisfactoriamente":"Banner invasivo enviado satisfactoriamente",
    "URL Imagen":"URL Imagen",
    "URL Redirección":"URL Redirección",
    "Contenido":"Contenido",
    "Texto del boton":"Texto del boton",
    "Usuarios Id":"Usuarios Id",
    "Fecha envío":"Fecha envío",
    "Fecha expiración":"Fecha expiración",
    "Enviar popup":"Enviar popup",
    "Título":"Título",
    "¿Es un juego?":"¿Es un juego?",
    "URL Frame":"URL Frame",
    "Popup enviado satisfactoriamente":"Popup enviado satisfactoriamente",
    "Enviar franja":"Enviar franja",
    "Franja enviada satisfactoriamente":"Franja enviada satisfactoriamente",
    "Saldo Asignado":"Saldo Asignado",
    "Todas": "Todas",
    "Expiradas":"Expiradas",
    "Proveedor pagos de retiros":"Proveedor pagos de retiros",
    "Añadir Ingreso Producto Cupo":"Añadir Ingreso Producto Cupo",
    "Producto:":"Producto:",
    "Cuenta Contable Cierre":"Cuenta Contable Cierre",
    "¿Somos agentes?":"¿Somos agentes?",
    "Máximo monto por retiro":"Máximo monto por retiro",
    "Máximo monto pago premio":"Máximo monto pago premio",
    "Por fecha de retiro pagado":"Por fecha de retiro pagado",
    "Banner Invasivo":"Banner Invasivo",
    "Popup":"Popup",
    "Franja":"Franja",
    "Fecha Caducidad Pago":"Fecha Caducidad Pago",
    "Enviar banner invasivo":"Enviar banner invasivo",
    "Enviar popup":"Enviar popup",
    "Enviar franja":"Enviar franja",
    "URL Imagen":"URL Imagen",
    "URL Redirección":"URL Redirección",
    "Contenido":"Contenido",
    "Texto del botón":"Texto del botón",
    "Usuarios Id":"Usuarios Id",
    "Fecha envío":"Fecha envío",
    "Fecha expiración":"Fecha expiración",
    "¿Es un juego?":"¿Es un juego?",
    "Ir al usuario":"Ir al usuario",
    "Categorías sin agregar":"Categorías sin agregar",
    "Categorías Producto Partner":"Categorías Producto Partner",
    "Explicación":"Explicación",
    "Seleccione por lo menos un Partner":"Seleccione por lo menos un Partner",
    "Partners Seleccionados":"Partners Seleccionados",
    "Partners no Seleccionados":"Partners no Seleccionados",
    "Sub Proveedor":"Sub Proveedor",
    "Franja Superior":"Franja Superior",
    "Desea Eliminar Egreso?":"Desea Eliminar Egreso?",
    "Eliminar Egreso":"Eliminar Egreso",
    "Egreso Eliminado":"Egreso Eliminado",
    "Desea Eliminar Ingreso?":"Desea Eliminar Ingreso?",
    "Eliminar Ingreso":"Eliminar Ingreso",
    "Ingreso Eliminado":"Ingreso Eliminado",
    "Apuestas Canceladas":"Apuestas Canceladas",
    "Partner Referencia":"Partner Referencia",
    "Tipo de registro":"Tipo de registro",
    "Especifique tipo de registro si es corto o largo":"Especifique tipo de registro si es corto o largo",
    "Corto":"Corto",
    "Largo":"Largo",
    "No Expiradas":"No Expiradas",
    "Plantillas":"Plantillas",
    "Plantilla email guardada":"Plantilla email guardada",
    "Plantilla sms guardada":"Plantilla sms guardada",
    "Ninguno":"Ninguno",
    "Pagado fisicamente":"Pagado fisicamente",
    "Rechazar nota de retiro":"Rechazar nota de retiro",
    "Elija la forma de pago":"Elija la forma de pago",
    "Pagar Nota":"Pagar Nota",
    "Desea Pagar Nota de Retiro?":"Desea Pagar Nota de Retiro?",
    "Nota de Retiro Rechazada":"Nota de Retiro Rechazada",
    "Nota de Retiro Aprobado":"Nota de Retiro Aprobado",
    "Reporte de billeteras":"Reporte de billeteras",
    "Desea Activar Billetera?":"Desea Activar Billetera?",
    "Activar Billetera":"Activar Billetera",
    "Billetera Activada":"Billetera Activada",
    "Desea Inactivar Billetera?":"Desea Inactivar Billetera?",
    "Inactivar Billetera":"Inactivar Billetera",
    "Billetera Inactivada":"Billetera Inactivada",
    "Resumido":"Resumido",
    "Configuración SEO":"Configuración SEO",
    "Leido?":"Leido?",
    "Información Extra":"Información Extra",
    "Reporte de transacciones del saldo":"Reporte de transacciones del saldo",
    "Desea aprobar notas de retiro seleccionadas?":"Desea aprobar notas de retiro seleccionadas?",
    "Aprobar Notas":"Aprobar Notas",
    "Notas de retiro aprobadas":"Notas de retiro aprobadas",
    "Seleccione por lo menos una nota de retiro para aprobar":"Seleccione por lo menos una nota de retiro para aprobar",
    "¿Es nuevo?":"¿Es nuevo?",
    "¿Esta seguro de realizar cambios en la configuración del SEO?":"¿Esta seguro de realizar cambios en la configuración del SEO?",
    "Añadir SEO":"Añadir SEO",
    "Idioma":"Idioma",
    "PÁGINA:":"PÁGINA:",
    "Historial de transferencias de saldo":"Historial de transferencias de saldo",
    "Confirme retracción de ":"Confirme retracción de ",
    "Retraer":"Retraer",
    "Transferir a Usuario":"Transferir a Usuario",
    "Retracción a Usuario":"Retracción a Usuario",
    "Valor Invalido":"Valor Invalido",
    "Activa o inactiva el tipo de saldo recargas":"Activa o inactiva el tipo de saldo recargas",
    "Activa o inactiva el tipo de saldo retiros":"Activa o inactiva el tipo de saldo retiros",
    "Saldo bonos":"Saldo bonos",
    "Activa o inactiva el tipo de saldo bonos":"Activa o inactiva el tipo de saldo bonos",
    "Saldo freebet":"Saldo freebet",
    "Activa o inactiva el tipo de saldo freebet":"Activa o inactiva el tipo de saldo freebet",
    "Saldo freecasino":"Saldo freecasino",
    "Activa o inactiva el tipo de saldo freecasino":"Activa o inactiva el tipo de saldo freecasino",
    "Retracción a Saldo Juego":"Retracción a Saldo Juego",
    "Retracción a Saldo Recargas":"Retracción a Saldo Recargas",
    "Sección":"Sección",
    "Id de transacción relacionada":"Id de transacción relacionada",
    "Historial de transferencias de saldo realizadas":"Historial de transferencias de saldo realizadas",
    "Historial de transferencias de saldo recibidas":"Historial de transferencias de saldo recibidas",
    "Transferir Saldo a ":"Transferir Saldo a ",
    "Consolidado nivel":"Consolidado nivel",
    "Historial de saldo agentes":"Historial de saldo agentes",
    "Historial de saldo usuario administrativo":"Historial de saldo usuario administrativo",
    "Bonos casino":"Bonos casino",
    "Bonos Virtuales":"Bonos Virtuales",
    "Bonos Casino en vivo":"Bonos Casino en vivo",
    "Fecha Cambio":"Fecha Cambio",
    "Fecha Acción":"Fecha Acción",
    "Fecha Cierre":"Fecha Cierre",
    "Usuario Pagó":"Usuario Pagó",
    "Impuesto Apuestas":"Impuesto Apuestas",
    "Impuesto Apuesta":"Impuesto Apuesta",
    "Impuesto Premios":"Impuesto Premios",
    "Impuesto Premio":"Impuesto Premio",
    "Con pasarelas de pago?":"Con pasarelas de pago?",
    "Su sesión se ha perdido, acceda nuevamente.":"Su sesión se ha perdido, acceda nuevamente.",
    "Aceptar":"Aceptar",
    "Con apuestas anuladas?":"Con apuestas anuladas?",
    "Con premios pendientes?":"Con premios pendientes?",
    "Esta nota de retiro no tiene permitido el pago por sistema":"Esta nota de retiro no tiene permitido el pago por sistema",
    "Agregar Archivo":"Agregar Archivo",
    "Se ha realizado la Actualización satisfactoriamente.":"Se ha realizado la Actualización satisfactoriamente.",
    "Historial de saldo máquinas":"Historial de saldo máquinas",
    "Flujo Caja Resumido Máquina":"Flujo Caja Resumido Máquina",
    "Máquina Productos":"Máquina Productos",
    "Máquina Proveedores":"Máquina Proveedores",
    "Máquina Sub Proveedores":"Máquina Sub Proveedores",
    "Máquina Tipo":"Máquina Tipo",
    "Máquina Referencia":"Máquina Referencia",
    "Categoría Máquina Editado":"Categoría Máquina Editado",
    "Producto Máquina Editado":"Producto Máquina Editado",
    "Proveedor Máquina Editado":"Proveedor Máquina Editado",
    "Sub Proveedor Máquina Editado":"Sub Proveedor Máquina Editado",
    "Tipo producto Máquina Editado":"Tipo producto Máquina Editado",
    "Agrupado sólo por usuario afiliador":"Agrupado sólo por usuario afiliador",
    "Id Sistema":"Id Sistema",
    "Ver sólo por punto de venta":"Ver sólo por punto de venta",
    "Proveedores internos":"Proveedores internos",
    "Programa de lealtad":"Programa de lealtad",
    "Puntos requeridos para el nivel 1":"Puntos requeridos para el nivel 1",
    "Puntos requeridos para el nivel 2":"Puntos requeridos para el nivel 2",
    "Puntos requeridos para el nivel 3":"Puntos requeridos para el nivel 3",
    "Puntos requeridos para el nivel 4":"Puntos requeridos para el nivel 4",
    "Puntos requeridos para el nivel 5":"Puntos requeridos para el nivel 5",
    "Puntos requeridos para el nivel 6":"Puntos requeridos para el nivel 6",
    "Puntos requeridos para el nivel 7":"Puntos requeridos para el nivel 7",
    "Puntos requeridos para el nivel 8":"Puntos requeridos para el nivel 8",
    "Puntos requeridos para el nivel 9":"Puntos requeridos para el nivel 9",
    "Puntos requeridos para el nivel 10":"Puntos requeridos para el nivel 10",
    "Monto depósito":"Monto depósito",
    "Monto (Dinero) requerido de los depósitos para obtener Z punto":"Monto (Dinero) requerido de los depósitos para obtener Z punto",
    "Deportiva simple":"Deportiva simple",
    "Monto (Dinero) requerido de una apuesta deportiva simple para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva simple para obtener Z punto",
    "Deportiva combinada de 2":"Deportiva combinada de 2",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 2 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 2 para obtener Z punto",
    "Deportiva combinada de 3":"Deportiva combinada de 3",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 3 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 3 para obtener Z punto",
    "Deportiva combinada de 4":"Deportiva combinada de 4",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 4 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 4 para obtener Z punto",
    "Deportiva combinada de 5":"Deportiva combinada de 5",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 5 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 5 para obtener Z punto",
    "Deportiva combinada de 6":"Deportiva combinada de 6",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 6 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 6 para obtener Z punto",
    "Deportiva combinada de 7":"Deportiva combinada de 7",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 7 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 7 para obtener Z punto",
    "Deportiva combinada de 8":"Deportiva combinada de 8",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 8 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 8 para obtener Z punto",
    "Deportiva combinada de 9":"Deportiva combinada de 9",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 9 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 9 para obtener Z punto",
    "Deportiva combinada de 10":"Deportiva combinada de 10",
    "Monto (Dinero) requerido de una apuesta deportiva Combinada de 10 para obtener Z punto":"Monto (Dinero) requerido de una apuesta deportiva Combinada de 10 para obtener Z punto",
    "Premios deportivos":"Premios deportivos",
    "Monto (Dinero) requerido de premios deportivos para obtener Z punto":"Monto (Dinero) requerido de premios deportivos para obtener Z punto",
    "Apuestas de casino":"Apuestas de casino",
    "Monto (Dinero) requerido de apuestas de casino para obtener Z punto":"Monto (Dinero) requerido de apuestas de casino para obtener Z punto",
    "Premios de casino":"Premios de casino",
    "Monto (Dinero) requerido de premios de casino para obtener Z punto":"Monto (Dinero) requerido de premios de casino para obtener Z punto",
    "Monto requerido de retiros":"Monto requerido de retiros",
    "Monto (Dinero) requerido de retiros para obtener Z punto":"Monto (Dinero) requerido de retiros para obtener Z punto",
    "Puntos Base":"Puntos Base",
    "Especifique el numero de puntos que se tomara como base, equivalente a Z en los demás items.":"Especifique el numero de puntos que se tomara como base, equivalente a Z en los demás items.",
    "Tipos de movimientos":"Tipos de movimientos",
    "Puntos equivalentes por nivel":"Puntos equivalentes por nivel",
    "IP de Cambio":"IP de Cambio",
    "Ip Acción":"Ip Acción",
    "Puntos Lealtad":"Puntos Lealtad",
    "Observaciones":"Observaciones",
    "Impuesto del GGR de la apuesta al momento de pagar":"Impuesto del GGR de la apuesta al momento de pagar",
    "Días de expiración de puntos":"Días de expiración de puntos",
    "Especifique el tiempo en días para la caducidad de los puntos":"Especifique el tiempo en días para la caducidad de los puntos",
    "Depositos:":"Depositos:",
    "Apuestas en Deportivas:":"Apuestas en Deportivas:",
    "Apuestas en Casino:":"Apuestas en Casino:",
    "Total Apuestas:":"Total Apuestas:",
    "Premios en Deportivas:":"Premios en Deportivas:",
    "Premios en Casino:":"Premios en Casino:",
    "Total Premios:":"Total Premios:",
    "Notas pendientes:":"Notas pendientes:",
    "Valor Retirado:":"Valor Retirado:",
    "Bonos:":"Bonos:",
    "Bonos Free Ganados:":"Bonos Free Ganados:",
    "Ajustes Entrada:":"Ajustes Entrada:",
    "Ajustes Salida:":"Ajustes Salida:",
    "Total:":"Total:",
    "Desea realizar movimiento?":"Desea realizar movimiento?",
    "Reporte de Sesiones Casino":"Reporte de Sesiones Casino",
    "Máximo monto retiro por punto de venta":"Máximo monto retiro por punto de venta",
    "Especifique el monto máximo para retirar por punto de venta":"Especifique el monto máximo para retirar por punto de venta",
    "Saldo al Final":"Saldo al Final",
    "Valor de depósitos":"Valor de depósitos",
    "Apuestas deportivas":"Apuestas deportivas",
    "Premios deportivos":"Premios deportivos",
    "Cancelaciones deportivas":"Cancelaciones deportivas",
    "Apuestas de casino":"Apuestas de casino",
    "Premios de casino":"Premios de casino",
    "Cancelaciones de casino":"Cancelaciones de casino",
    "Retiros realizados":"Retiros realizados",
    "Retiros cancelados":"Retiros cancelados",
    "Bonos redimidos":"Bonos redimidos",
    "Encriptación":"Encriptación",
    "Desea imprimir recibo?":"Desea imprimir recibo?",
    "Imprimir":"Imprimir",
    "Verificó domicilio":"Verificó domicilio",
    "Link Afiliados:":"Link Afiliados:",
    "QR Afiliados:":"QR Afiliados:",
    "Saldo:":"Saldo:",
    "Billetera":"Billetera",
    "Comisión":"Comisión",
    "Transferencias recibidas":"Transferencias recibidas",
    "Transferencias realizadas":"Transferencias realizadas",
    "Reporte de Afiliados":"Reporte de Afiliados",
    "Recepcion de Efectivo":"Recepcion de Efectivo",
    "ID Billetera":"ID Billetera",
    "Reporte de Billeteras":"Reporte de Billeteras",
    "Desea Inactivar Billetera?":"Desea Inactivar Billetera?",
    "Billetera Inactivada":"Billetera Inactivada",
    "Billeteras":"Billeteras",
    "Cupones":"Cupones",
    "Desea enviar el cupón?":"Desea enviar el cupón?",
    "Cupón Enviado Satisfactoriamente":"Cupón Enviado Satisfactoriamente",
    "No tiene permitido el pago por sistema":"No tiene permitido el pago por sistema",
    "Impuesto al pago de premio (GGR)":"Impuesto al pago de premio (GGR)",
    "Es Propio?":"Es Propio?",
    "Tipo de Punto":"Tipo de Punto",
    "Físico":"Físico",
    "(Nota: Por cada monto en XXX va a obtener Z puntos base)":"(Nota: Por cada monto en XXX va a obtener Z puntos base)",
    "Número de teléfono:":"Número de teléfono:",
    "Tipo de establecimiento":"Tipo de establecimiento",
    "Sportbook NGR Afiliados":"Sportbook NGR Afiliados",
    "Sportbook GGR Punto venta IP":"Sportbook GGR Punto venta IP",
    "Sportbook GGR Punto venta":"Sportbook GGR Punto venta",
    "Deposito Punto venta":"Deposito Punto venta",
    "Nro. de Agente:":"Nro. de Agente:",
    "Nombre del agente:":"Nombre del agente:",
    "Recargar Credito Agente":"Recargar Credito Agente",
    "Solo Saldos Negativos":"Solo Saldos Negativos",
    "Contingencia Total":"Contingencia Total",
    "Contingencia Deportivas":"Contingencia Deportivas",
    "Contingencia Casino":"Contingencia Casino",
    "Contingencia Casino en Vivo":"Contingencia Casino en Vivo",
    "Contingencia Virtuales":"Contingencia Virtuales",
    "Contingencia Poker":"Contingencia Poker",
    "Contingencia Retiro":"Contingencia Retiro",
    "Contingencia Depósito":"Contingencia Depósito",
    "Contingencia masiva":"Contingencia masiva",
    "Cargar archivo CSV":"Cargar archivo CSV",
    "Contingencia masiva creada":"Contingencia masiva creada",
    "V. Entradas Recargas Agentes":"V. Entradas Recargas Agentes",
    "Valor Entradas Recargas Agentes":"Valor Entradas Recargas Agentes",
    "Configuración Tabla":"Configuración Tabla",
    "No tiene permitido esta acción":"No tiene permitido esta acción",
    "Añadir bono masivo":"Añadir bono masivo",
    "Tipo Transferencia":"Tipo Transferencia",
    "Tipo Reporte":"Tipo Reporte",
    "GGR. Deportivas":"GGR. Deportivas",
    "GGR. Casino":"GGR. Casino",
    "Tipoo":"Tipo",
    "Sucursal bancaria":"Sucursal bancaria",
    "Tipo de ajuste":"Tipo de ajuste",
    "Fraude":"Fraude",
    "Traslado usuario inactivado":"Traslado usuario inactivado",
    "Redondeo":"Redondeo",
    "Apuestas erróneas casino":"Apuestas erróneas casino",
    "Pruebas":"Pruebas",
    "Otros":"Otros",
    "Cedula de Ciudadania":"Cedula de Ciudadania",
    "Cedula de Extranjeria":"Cedula de Extranjeria",
    "Recargas Anuladas":"Recargas Anuladas",
    "Id punto de venta":"Id punto de venta",
    "Nombre punto de venta":"Nombre punto de venta",
    "Reportes personalizados":"Reportes personalizados",
    "Generado":"Generado",
    "Cantidad Registros":"Cantidad Registros",
    "Solicitar Reporte":"Solicitar Reporte",
    "Link Reporte":"Link Reporte",
    "Reporte solicitado correctamente":"Reporte solicitado correctamente",
    "Buscar Permiso":"Buscar Permiso",
    "Global":"Global",
    "Operación":"Operación",
    "Permisos":"Permisos",
    "Denegación":"Denegación",
    "Desea rechazar notas de retiro seleccionadas?":"Desea rechazar notas de retiro seleccionadas?",
    "Rechazar Notas":"Rechazar Notas",
    "Notas de retiro rechazadas":"Notas de retiro rechazadas",
    "Seleccione por lo menos una nota de retiro para rechazar":"Seleccione por lo menos una nota de retiro para rechazar",
    "Sitio":"Sitio",
    "Desea Anular Transferencia?":"Desea Anular Transferencia?",
    "Anular Transferencia":"Anular Transferencia",
    "Transferencia Anulada":"Transferencia Anulada",
    "Monto y confirmar monto no coinciden":"Monto y confirmar monto no coinciden",
    "Olvidó su contraseña?":"Olvidó su contraseña?",
    "Se ha enviado correctamente el mensaje, te llegará un correo electrónico con la información.":"Se ha enviado correctamente el mensaje, te llegará un correo electrónico con la información.",
    "Email Inválido":"Email Inválido",
    "Mínimo 8 caracteres, una minúscula, una mayúscula y un número.":"Mínimo 8 caracteres, una minúscula, una mayúscula y un número.",
    "Contraseña cambiada satisfactoriamente.":"Contraseña cambiada satisfactoriamente.",
    "Nueva contraseña y confirmar contraseña no coinciden.":"Nueva contraseña y confirmar contraseña no coinciden.",
    "Nro. de Usuario:":"Nro. de Usuario:",
    "Nombre del Usuario:":"Nombre del Usuario:",
    "Reporte bonos redimidos":"Reporte bonos redimidos",
    "Fecha Redimió":"Fecha Redimió",
    "ERROR10001":"Existe transacción para el proveedor",
    "ERROR10002":"Monto negativo",
    "ERROR10003":"Valor ticket diferente a rollback",
    "ERROR10004":"Debit con rollback antes",
    "ERROR10005":"No existe la transacción",
    "ERROR10006":"La transacción no es debit",
    "ERROR10007":"Detalles de la trasacción no coinciden",
    "ERROR10008":"Valor de la transacción anterior diferente",
    "ERROR10009":"",
    "ERROR10010":"Transaccion Juego Existe",
    "ERROR10011":"Token vacío",
    "ERROR10012":"Token ya existe",
    "ERROR10013":"UID vacío",
    "ERROR10014":"# Debit diferente a # Credit",
    "ERROR10015":"Trasacción con rollback",
    "ERROR10016":"Ronda cerrada",
    "ERROR10017":"Moneda Incorrecta",
    "ERROR10018":"Código de país incorrecto",
    "ERROR10019":"",
    "ERROR10020":"Campo vacio",
    "ERROR10021":"UsuarioId vacío",
    "ERROR10022":"",
    "ERROR10023":"",
    "ERROR10024":"",
    "ERROR10025":"Ticket ID ya existe",
    "ERROR10026":"Ticket ID no existe",
    "ERROR10030":"Token Inactivo",
    "ERROR10031":"BettypeID Ezugi incorrecto",
    "ERROR10035":"Usuario no tiene permiso para realizar esta acción",
    "ERROR10027":"El ticket ya esta cerrado",
    "ERROR19000":"La cédula ya existe",
    "ERROR19001":"El login ya esta registrado",
    "ERROR20000":"Sesion del usuario expirada o invalida",
    "ERROR20001":"Fondos insuficientes",
    "ERROR20002":"SIGN incorrecto",
    "ERROR20003":"Usuario Inactivo",
    "ERROR20004":"Autoexclusion Casino Producto Interno",
    "ERROR20005":"Autoexclusion Casino Categoria",
    "ERROR20006":"Autoexclusion Casino SubCategoria",
    "ERROR20007":"Autoexclusion Casino Juego",
    "ERROR20008":"Limite de deposito simple",
    "ERROR20009":"Limite de deposito diario",
    "ERROR20010":"Limite de deposito semanal",
    "ERROR20011":"Limite de deposito mensual",
    "ERROR20012":"Limite de deposito anual",
    "ERROR20013":"Limite de casino simple",
    "ERROR20014":"Limite de casino diario",
    "ERROR20015":"Limite de casino semanal",
    "ERROR20016":"Limite de casino mensual",
    "ERROR20017":"Limite de casino anual",
    "ERROR20018":"Limite de casino en vivo simple",
    "ERROR20019":"Limite de casino en vivo diario",
    "ERROR20020":"Limite de casino en vivo semanal",
    "ERROR20021":"Limite de casino en vivo mensual",
    "ERROR20022":"Limite de casino en vivo anual",
    "ERROR20023":"Casino Inactivo",
    "ERROR20024":"Casino en Contingencia",
    "ERROR20025":"LiveCasino Inactivo",
    "ERROR20026":"LiveCasino en Contingencia",
    "ERROR20027":"Usuario autoexcluido total por tiempo",
    "ERROR20028":"Usuario autoexcluido total",
    "ERROR20029":"El usuario no esta registrado en la plataforma (Eliminado)",
    "ERROR21000":"No se encuentra el numero de retiro",
    "ERROR21001":"El retiro ya fue procesado",
    "ERROR21002":"Valor menor al minimo permitido para retirar",
    "ERROR21003":"Valor mayor al máximo permitido para retirar",
    "ERROR21004":"La cuenta necesita estar verificada para poder retirar",
    "ERROR21005":"El registro debe de estar aprobado para poder retirar",
    "ERROR21006":"Este usuario aún no ha completado su verificación. No se puede realizar depósitos",
    "ERROR21007":"El registro debe de estar aprobado para poder depositar",
    "ERROR21008":"Valor menor al minimo permitido para depositar",
    "ERROR21009":"Valor mayor al máximo permitido para depositar",
    "ERROR21010":"Producto no disponible",
    "ERROR21011":"Tienes el máximo de notas de retiro permitidas activas",
    "ERROR30001":"Usuario Bloqueado por minima cantidad de logueos incorrectos",
    "ERROR30002":"Usuario (Login) no existe",
    "ERROR30003":"Login con contraseña incorrectos",
    "ERROR30004":"En el momento nos encontramos en proceso de mantenimiento del sitio",
    "ERROR30005":"Usuario con registro inactivo",
    "ERROR30006":"El usuario excede el número de cuentas bancarias registradas permitidas",
    "ERROR30007":"La clave ingresada es incorrecta",
    "ERROR30008":"El codigo de bono ingresado es incorrecto",
    "ERROR30009":"Billetera no configurada -> QUISK",
    "ERROR30010":"No puede iniciar sesion en el sitio.",
    "ERROR30011":"Usuario no coincide con token",
    "ERROR30012":"Player Id was not found for the roundId",
    "ERROR30013":"Game was not found for the roundId",
    "ERROR30014":"UserId is different from the Wager UserId that needed to be cancelled",
    "ERROR30015":"",
    "ERROR30017":"La ronda ya ha sido finalizada",
    "ERROR30018":"La ronda ya ha sido cancelada",
    "ERROR30020":"",
    "ERROR30021":"",
    "ERROR50001":"",
    "ERROR50002":"Bono para lealtad no disponible",
    "ERROR50030":"La ronda ya ha sido finalizada",
    "ERROR60001":"",
    "ERROR60002":"Error en los datos enviados",
    "ERROR60003":"La solicitud al mandante fue vacia",
    "ERROR100000":"",
    "ERROR100001":"Error en la solicitud. Error en los parametros enviados (Report#100001)",
    "ERROR100002":"",
    "ERROR100003":"Rechazada por Automation",
    "ERROR100004":"Error en la solicitud. No dispone de autorizacion para ejecutar esta operacion",
    "ERROR100005":"Error en la solicitud. Excedió el cupo máximo permitido de recarga. Consulte con su administrador (Report#100005)",
    "ERROR100010":"",
    "ERROR100011":"",
    "ERROR100012":"Error General",
    "ERROR100013":"Error en los parametros enviados",
    "ERROR100030":"Punto de venta no tiene cupo disponible para realizar la recarga",
    "ERROR100086":"El usuario tiene una verificación pendiente",
    "ERROR110005":"Este punto de venta no tiene autorizado hacer notas de retiro",
    "ERROR110006":"No es posible anular esta recarga por antigüedad",
    "ERROR110007":"Has alcanzado el máximo de cancelaciones de depósitos por día",
    "ERROR300152": "Este usuario no puede usar puntos de venta o red aliadas, comuníquese con soporte",
    "ERROR300155":"¡Atención! Para canjear tus puntos, primero debes verificar tu cuenta. Completa tu verificación y sigue disfrutando de tus beneficios",
    "ERROR300167":"Esta cuenta tiene una restricción activa. El usuario debe comunicarse con soporte para más información.",
    "ERROR300180":"Esta combinación ya ha sido registrada",
    "ERROR300181":"La criptomoneda seleccionada está inactiva. No puede ser asociada",
    "ERROR300182":"La red seleccionada está inactiva. Debe activarla para poder usarla",
    "ERROR300172":"Red asociada a una criptomoneda, el codigo de red no se puede cambiar",
    "ERROR300173":"El código de red ingresado ya existe en el sistema",
    "ERROR100035":"Permiso Denegado",
    "ERROR300023": "Debe completar todos los campos requeridos",
    "ERROR300176": "Solo se permiten imágenes en formato PNG o JPG",
    "ERROR300177": "Esta criptomoneda ya está registrada",
    "ERROR300178": "Dimensiones de imagen invalida",
    "ERROR300045": "Este producto ya está asociado a esta combinación",
    "ERROR300044": "La combinación seleccionada está inactiva y no puede usarse",
    "ERROR300092": "Producto no disponible. No es posible realizar el pago de la solicitud de retiro.",
    "ERROR300221": "El límite de archivos a procesar por lote es de 40.",
    "ERROR3002062": "No fue posible registrar al jugador en Stradacarte. Intenta nuevamente.",
    "Fecha de creación punto de venta":"Fecha de creación punto de venta",
    "ProviderNameGroup": "Proveedor",
    "Id": "Id",
    "Date": "Fecha",
    "Username": "Usuario",
    "Game": "Juego",
    "Identifier": "Identificador",
    "ProviderName": "Proveedor",
    "Bets": "Apuestas",
    "TaxBet": "Impuesto Apuesta",
    "Tax": "Impuesto Premios",
    "Stakes": "Apuestas",
    "FreeBalance": "Saldo Gratis",
    "Winnings": "Premios",
    "Bonus": "Bonos",
    "Profit": "GGR",
    "WinningsBonus": "Premios Bonos",
    "Profitness": "% GGR",
    "TransactionId": "Transacción ID",
    "Type": "Tipo",
    "Amount": "Valor",
    "Name": "Nombre",
    "IsActivate": "Estado",
    "IsVerified": "Verificado",
    "Abbreviated": "Abreviado",
    "TypeDevice": "Dispositivo",
    "Image": "Imagen",
    "ImageURL": "Imagen URL",
    "ProviderId": "Proveedor",
    "SubProviderId": "SubProveedor",
    "ExternalId": "External ID",
    "Visible": "Visible",
    "Provider": "Proveedor",
    "Partner": "Partner",
    "FilterCountry": "Filtro País",
    "Maximum": "Máximo",
    "Minimum": "Mínimo",
    "Detail": "Detalle",
    "SiteId": "Site ID",
    "Key": "Clave",
    "Url": "URL API",
    "TypeIntegration": "Tipo de integración",
    "Contingency": "Contingencia",
    "Product": "Producto",
    "Mobile": "Mobile",
    "Desktop": "Escritorio",
    "ProcessingTime": "Tiempo Procesamiento",
    "Order": "Orden",
    "FeaturedOrder": "Orden Destacado",
    "Rows": "Filas",
    "Columns": "Columnas",
    "New": "¿Es nuevo?",
    "Description": "Observación",
    "Slug": "Slug",
    "Superior": "Superior",
    "Categorie": "Categoría",
    "Login": "Login",
    "FirstName": "Nombre",
    "LastName": "Apellido",
    "DocNumber": "Documento",
    "DNI": "DNI",
    "Ip": "IP",
    "MobilePhone": "Teléfono",
    "IsRegisterActivate": "Estado de Registro",
    "CreatedLocalDate": "Fecha de creación",
    "LastLoginLocalDate": "Fecha del ultimo logueo",
    "CodePromotional": "Codigo Promocional",
    "IdCodePromotional": "Id Codigo Promocional",
    "Site": "Sitio",
    "ClientId": "ID Cliente",
    "CreatedLocal": "Fecha Creación",
    "PaymentSystemName": "Nombre Sistema Pasarela Pago",
    "TypeName": "Tipo",
    "CurrencyId": "Moneda",
    "Commission": "Comisión",
    "ModifiedLocal": "Modificado",
    "State": "Estado",
    "CashDeskId": "Recepcion de Efectivo",
    "UserId": "ID Usuario",
    "BetShopName": "Punto de Venta",
    "PaymentDate": "Fecha Pagado",
    "ByAllowDate": "Por fecha de retiro pagado",
    "UserModifId": "Modificó",
    "PlayerId": "ID Usuario",
    "UserName": "UserName",
    "Category": "Categorías",
    "SubCategory": "Sub Categoría",
    "FinalDate": "Fecha final de la autoexclusión",
    "Reason": "Motivo Autoexclusión",
    "AutoAmount": "Numero Autoexclusiónes",
    "UserCreation": "Usuario Creación",
    "UserModified": "Usuario Modificó",
    "OtherBonus": "Otros Bonos",
    "TaxPayout": "Impuesto Premios",
    "Code": "Code",
    "CreateLocalDate": "Fecha Creación",
    "Currency": "Moneda",
    "AmountDeposit": "Saldo recargas",
    "AmountWithdraw": "Saldo retiros",
    "PartnerBonusId": "Id Bono",
    "PartnerBonusName": "Nombre de Bono",
    "AcceptanceDateLocal": "Fecha Aceptación",
    "BonusType": "Tipo",
    "AmountConverted": "Monto Convertido",
    "RolloverRequired": "Rollover Requerido",
    "RolloverWagered": "Apostado",
    "RolloverRemaining": "Restante",
    "ClientBonusExpirationDateLocal": "Fecha Expiración",
    "Fecha": "Fecha",
    "Moneda": "Moneda",
    "CantidadTickets": "Cantidad Tickets",
    "ValorEntradasEfectivo": "V.Entradas Efectivo",
    "ValorEntradasBonoTC": "V.Entradas Bono/T.C",
    "ValorEntradasTraslados": "V.Entradas Traslados",
    "ValorEntradasRecargas": "V.Entradas Recargas",
    "ValorSalidasEfectivo": "V.Salidas Efectivo",
    "ValorSalidasTraslados": "V.Salidas Traslados",
    "ValorSalidasNotasRetiro": "V.Salidas N.Retiro",
    "Saldo": "Saldo",
    "VoidedPlacedBets": "Apuestas Anuladas",
    "ValorEntradasEfectivoNeto": "V.Entradas Efectivo Neto",
    "RecargasAnuladas": "Recargas Anuladas",
    "VoidedPaidBets": "Apuestas Pagadas Anuladas",
    "ValorEntradasEfectivoDeportivo": "Entrada en Efectivo - Apuestas Deportivas ",
    "ValorEntradasEfectivoCasino": "Entrada en Efectivo - Apuestas Virtuales ",
    "ValorSalidaEfectivoDeportivas": "Salida en Efectivo - Apuestas Deportivas ",
    "ValorSalidaEfectivoCasino": "Salida en Efectivo - Apuestas Virtuales ",
    "ValorSalidasEfectivoNeto": "V.Salidas Efectivo Neto",
    "Stake": "Valor Apostado",
    "StakePromedio": "Apuesta Promedio",
    "Payout": "Valor premios",
    "Bonos": "Bonos",
    "Ggr": "GGR",
    "GgrPorc": "GGR %",
    "UsersRegistered": "Usuarios Registrados",
    "FirstDeposits": "Primeros Depósitos",
    "TypeBet": "Tipo de Apuesta",
    "BetShop": "Punto de Venta",
    "DatePayment": "Fecha de pago",
    "BetShopPayment": "Punto Venta Pagó",
    "Cashier": "Cajero",
    "ClosingDate": "Fecha Cierre",
    "WinningAmount": "Premios",
    "WinningAmountTotal": "Premio Total",
    "Odds": "Odds",
    "UserIP": "IP",
    "Wallet": "Billetera",
    "TicketId": "Ticket ID",
    "CantidadTicketsCasino": "Cant Tickets Casino",
    "CantidadTicketsCasinoVivo": "Cant Tickets Casino Vivo",
    "TotalTickets": "Total Tickets",
    "AmountDeposits": "Depósitos",
    "AmountWinnings": "Saldo Disp Retiro",
    "Deposits": "Valor Recargas",
    "WithdrawPending": "Nota de retiro pendiente",
    "Paid": "Valor Pagado",
    "StakeCasino": "Vlr Ap. Casino",
    "StakeLiveCasino": "Vlr Ap. Casino Vivo",
    "TotalStake": "Total Apostado",
    "PayoutCasino": "Vlr Pr. Casino",
    "PayoutLiveCasino": "Vlr Pr. Casino Vivo",
    "TotalPayout": "Total premios",
    "Ticket": "Ticket",
    "UserPartner": "Usuario Partner",
    "UserAggregator": "User Aggregator",
    "CreationDate": "Fecha Creación",
    "ValueBet": "Valor Apostado",
    "ValuePrize": "Valor Premio",
    "TypeBalance": "Tipo",
    "UserCreated": "Usuario Creo",
    "BeforeAdjust": "Saldo Antes de Ajuste",
    "AfterAdjust": "Saldo Despues de Ajuste",
    "Ticked Id": "Ticked Id",
    "Value": "Valor",
    "Movement": "Movimiento",
    "BalanceDeposit": "Saldo recargas",
    "BalanceWithdrawal": "Saldo retiros",
    "Country": "País",
    "BalanceInitial": "Saldo Inicial",
    "AmountBets": "Ap. Deportivas",
    "AmountWin": "Pr. Deportivas",
    "GgrAmountWin": "GGR. Deportivas",
    "AmountBetsCasino": "Transf Apuesta S",
    "AmountWinCasino": "Transf Apuesta E",
    "GgrAmountWinCasino": "GGR. Casino",
    "WithdrawCreates": "Retiros Creados",
    "WithdrawDeletes": "Recargas Eliminadas",
    "AdjustmentE": "Transf Recarga E",
    "AdjustmentS": "Transf Recarga S",
    "BonusCasino": "Bonos casino",
    "BonusVirtual": "Bonos Virtuales",
    "BonusCasinoLive": "Bonos Casino en vivo",
    "BalanceEnd": "Saldo Final",
    "BalanceEndCalc": "Saldo Final Calc.",
    "BalanceGap": "Calc. Desfase",
    "WithdrawPaid": "Retiros Pagados",
    "WithdrawPend": "Retiros Pendientes",
    "BonusFreeWin": "Bonos Free Ganados",
    "DepositsUsersCount": "Usuarios Depositantes",
    "DepositsCount": "Cantidad Depositos",
    "InitialRechargeQuota": "Cupo recargas inicial",
    "InitialGameQuota": "Cupo juego inicial",
    "EndGameQuota": "Cupo",
    "EndGameQuotaCalc": "Cupo Calc.",
    "Route": "Ruta",
    "Version": "Versión",
    "EncryptionValue": "Encriptación",
    "NameAffiliate": "Nombre Afiliador",
    "ClientRef": "Usuario REF",
    "AmountBase": "Valor Base",
    "AmountPaid": "Valor Pagado",
    "TypeQuota": "Tipo Cupo",
    "TypeTransaction": "Tipo Transacción",
    "Assigned": "Asignado Por",
    "SessionId": "ID Sesión",
    "StartTime": "Fecha Creación",
    "EndTime": "Fecha Modificación",
    "CreatedDate": "Fecha de creación",
    "AmountBetting": "Saldo",
    "RegionName": "Región",
    "DepartmentName": "Departamento",
    "CityName": "Ciudad",
    "Phone": "Celular",
    "Address": "Dirección",
    "LastLoginDateLabel": "Fecha de ultimo login",
    "Email": "Email",
    "StateValidate": "Estado Validación",
    "Action": "Transf.",
    "AgentBalance": "Saldo",
    "SumAgentBalance": "Consolidado nivel",
    "FinalId": "ID Final",
    "WayPay": "Forma de pago",
    "PaymentMethod": "Método de pago",
    "TypeAccount": "Tipo de cuenta",
    "AccountBank": "Cuenta Bancaria",
    "BranchBank": "Sucursal bancaria",
    "CodeInterbank": "Código Interbancario",
    "VerifdniAnt": "DNI",
    "TypeDocument": "Tipo Documento",
    "Identification": "Cedula",
    "ClientName": "Nombre Cliente",
    "Department": "Departamento",
    "City": "Ciudad",
    "ChangeDate": "Fecha Cambio",
    "ChangeIp": "IP de Cambio",
    "ActionDate": "Fecha Acción",
    "ActionIp": "Ip Acción",
    "SystemId": "Id Sistema",
    "Site Builderg":"Site Builder",
    "TournamentRegistration": 'Id de torneo',
    "BetTournament": 'Apuestas Torneo',
    "WinTournament": 'Ganancia Torneo',
    "user": 'Id Casino Usuario',
    "RiskStatus": "Nivel de Riesgo",
    "LoyaltyLevel": "Nivel de Lealtad",
    "AccumulatedDepositsValue":"Valor de depósito acumulado",
    "AccumulatedWithdrawalsValue":"Valor de retiro acumulado",
    "AccumulatedAwardsValue":"Valor acumulado de premios",
    "AccumulatedGGRValue":"Valor acumulado de GGT",
    "AccumulatedBetsValue":"Valor acumulado de apuestas",
    "ValueLastWithdrawal":"Valor último retiro",
    "ValueLastDeposit":"Valor último depósito",
    "DocExpirationDate":"Fecha de expiración del documento",
    "ValueLastWithdraw":"Valor último retiro",
    "PrematchAwards": "Premios PREMATCH",
    "LiveAwards": "Premios LIVE",
    "StakesBonus":"Apuestas Bonos",
    "Trm":"TRM Aplicada",
    "CriptoAmount":"Monto Cripto",
    "expirationDate":"Fecha de Expiración",
    "Comprobante de pago":"Comprobante de pago",
    "Comprobante no disponible":"Comprobante no disponible",
    "Fecha de la transacción":"Fecha de la transacción",
    "Valor del depósito":"Valor del depósito",
    "Acciones": "Acciones",
    "Nombre del documento": "Nombre del documento",
    "Tipo de documento": "Tipo de documento",
    "Fecha de carga": "Fecha de carga",
    "Cantidad de perfiles autorizados": "Cantidad de perfiles autorizados",
    "Visualizar archivo": "Visualizar archivo",
    "Cargando...": "Cargando...",
    "No se pudo obtener el archivo": "No se pudo obtener el archivo",
    "Archivo actual: ": "Archivo actual: ",
    "Archivo seleccionado: ": "Archivo seleccionado: ",
    "¿Desea inactivar el documento?": "¿Desea inactivar el documento?",
    "Documento creado correctamente.": "Documento creado correctamente.",
    "Documento actualizado correctamente.": "Documento actualizado correctamente.",
    "Archivo reemplazado correctamente.": "Archivo reemplazado correctamente.",
    "Documento inactivado correctamente.": "Documento inactivado correctamente.",
    "No se pudo obtener el documento": "No se pudo obtener el documento",
    "Vista previa no disponible, descarga el archivo": "Vista previa no disponible, descarga el archivo",
    "Vista previa no disponible": "Vista previa no disponible",
    "No se pudo aceptar el documento, intenta nuevamente.": "No se pudo aceptar el documento, intenta nuevamente.",
    "No se pudo cargar el documento, intenta nuevamente más tarde.": "No se pudo cargar el documento, intenta nuevamente más tarde.",
    "Archivo": "Archivo",
    "Cargar Archivo": "Cargar Archivo",
    "Debes adjuntar un archivo": "Debes adjuntar un archivo",
    "El formato del archivo no es válido": "El formato del archivo no es válido",
    "El tamaño máximo permitido es de 5MB": "El tamaño máximo permitido es de 5MB",
    "perfiles seleccionados": "perfiles seleccionados",
    "Documentos": "Documentos",
    "Fecha de publicación": "Fecha de publicación",
    "Tipo de acceso": "Tipo de acceso",
}

// FILE DOCUMENTED
